<template>
  <div class="l-home-layout-wrapper h-[calc(100vh-30px)] w-full flex">
    <div class="left-sidebar-layout theme-reset flex-shrink-0 w-[66px] h-full relative flex-col-items-center z-[1] pb-[63px]" :theme="bar_theme">
      <div 
        class="shortcuts" 
        ref="shortcuts-scroller" 
        @contextmenu.prevent.stop="shortCutsWrapperMenuHandler"
        >
        <div class="cpt-shortcut-block-wrapper">
          <div
            class="shortcut-block circle chat-icon z-[101]"
            :class="{
              active: $route.name === 'home',
              gray: !chatIconHover && $route.name !== 'home'
            }"
            @click="jumpTo('home')"
            v-tooltip="{'text': '黑盒语音', placement: 'right', 'popperClass': 'tooltip-roombar-text'}"
            @mouseenter="chatIconHover = true"
            @mouseleave="chatIconHover = false"
          >
            <img src="@/assets/images/chat-icon.png" alt="黑盒语音" v-if="chatIconHover || $route.name === 'home'"/>
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none" v-else>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M17.3268 13.1022L14.4672 17.6758C14.4216 17.7487 14.3988 17.7852 14.3898 17.8243C14.3818 17.859 14.3817 17.8949 14.3894 17.9296C14.3981 17.9688 14.4206 18.0054 14.4657 18.0787L16.6343 21.6065C16.7404 21.779 16.7934 21.8652 16.8619 21.8952C16.9218 21.9215 16.9897 21.922 17.05 21.8968C17.119 21.8679 17.1735 21.7826 17.2824 21.6119L26.0326 7.89585C26.5827 7.03353 26.8578 6.60237 26.8314 6.24602C26.8085 5.93546 26.6521 5.6501 26.4026 5.46372C26.1163 5.24988 25.6049 5.24988 24.5821 5.24988H22.5237C22.447 5.24988 22.4086 5.24988 22.374 5.26066C22.3433 5.2702 22.3148 5.28583 22.2903 5.30661C22.2627 5.33009 22.2421 5.36248 22.201 5.42725L17.3268 13.1022ZM20.8038 5.24988C21.0306 5.24988 21.144 5.24988 21.2076 5.29731C21.263 5.33865 21.2978 5.40196 21.303 5.4709C21.309 5.55 21.2482 5.64574 21.1266 5.83721L18.5011 9.97138C18.46 10.0362 18.4394 10.0685 18.4117 10.092C18.3872 10.1128 18.3588 10.1284 18.3281 10.138C18.2934 10.1488 18.2551 10.1488 18.1783 10.1488H13.1001C13.1001 10.1488 13.1001 10.1487 13.1001 10.1487V10.1487C13.1001 10.1487 13.1001 10.1487 13.1001 10.1487H3.61393C3.53737 10.1487 3.4991 10.1487 3.4645 10.138C3.43388 10.1285 3.40548 10.1129 3.381 10.0922C3.35334 10.0688 3.33276 10.0365 3.29159 9.97201L1.96709 7.89585C1.41697 7.03353 1.14191 6.60237 1.16823 6.24602C1.19117 5.93546 1.34761 5.6501 1.59709 5.46372C1.88335 5.24988 2.39477 5.24988 3.41762 5.24988H20.8038ZM4.55913 10.8656C4.33183 10.8656 4.21818 10.8656 4.15457 10.9132C4.09913 10.9546 4.06436 11.018 4.05927 11.087C4.05342 11.1662 4.11454 11.262 4.23679 11.4536L12.7105 24.7362C13.1392 25.4082 13.3535 25.7442 13.6266 25.86C13.8651 25.9612 14.1345 25.9612 14.3731 25.86C14.6462 25.7442 14.8605 25.4082 15.2892 24.7362L16.4148 22.9718C16.4615 22.8986 16.4849 22.862 16.4942 22.8226C16.5024 22.7877 16.5027 22.7515 16.4951 22.7165C16.4864 22.6769 16.4637 22.6399 16.4182 22.5659L12.9118 16.8621L9.27479 11.0453C9.23379 10.9797 9.21329 10.9469 9.18552 10.9231C9.16095 10.9021 9.13236 10.8862 9.10149 10.8766C9.0666 10.8656 9.02793 10.8656 8.9506 10.8656H4.55913Z" fill="var(--opacity-5)"/>
            </svg>
          </div>
        </div>
        
        <div
          class="cpt-shortcut-block-wrapper friends-msg-wrapper"
          :class="{ 'sticky-friends-msg': showFriendsMsgSticky }"
          v-remind-to-login="{cb: () => { jumpTo('friends') }}"
          ref="friends-center-tip"
          :style="showFriendsMsgSticky ? `background: ${show_theme_data.bar_color ? show_theme_data.bar_color[0] : 'var(--fill-navi)'}; --friends-mask-color: ${show_theme_data.bar_color ? show_theme_data.bar_color[0] : 'var(--fill-navi)'}` : `--friends-mask-color: ${show_theme_data.bar_color ? show_theme_data.bar_color[0] : 'var(--fill-navi)'}`"
          v-show="isCompleted.every(item => item)"
        >
          <div
            class="tool-shortcuts shortcut-block circle" 
            :class="{
              active: $route.name === 'friends',
            }"
            v-tooltip="{
              text: '好友与消息',
              placement: 'right',
              popperClass: 'tooltip-roombar-text'
            }"
          >
            <img src="https://imgheybox.max-c.com/oa/2025/05/14/0fd494c5bf0ae8bbf0bbd1ee7c601191.png" alt="消息中心" class="tool-img"/>
            <RedNum
              v-if="recent_msg_count"
              :num="recent_msg_count"
              :isHasBorder="true"
              :border-color="show_theme_data.bar_color ? show_theme_data.bar_color[0] : ''"
            ></RedNum>
          </div>
        </div>

        <FriendsGuideDialog
          v-if="showFriendsCenterTip"
          @close="handleFriendsCenterTipClose"
        ></FriendsGuideDialog>

        <div ref="shortcuts-list" class="w-full" v-show="isCompleted.every(item => item)">
          <!-- 工具列表 -->
          <div class="tool-container flex-col-items-center relative pb-[6px]">
            <template>
              <div
                class="cpt-shortcut-block-wrapper"
                v-remind-to-login="{cb: () => { jumpTo('mini-program') }}"
              >
                <div
                  class="tool-shortcuts shortcut-block circle relative" 
                  :class="{
                    active: $route.name === 'mini-program',
                  }"
                  v-tooltip="{
                    text: '小程序平台',
                    placement: 'right',
                    popperClass: 'tooltip-roombar-text'
                  }"
                >
                  <img src="https://imgheybox.max-c.com/oa/2025/05/13/a18220494f96671f21c07a1ab0309ade.png" alt="小程序" class="tool-img"/>
                  <div 
                    class="w-[12px] h-[12px] absolute top-[-1px] right-[-3px] bg-er-fl rounded-[50%] border-[2px] border-solid border-fl-2" 
                    v-if="user_account_settings.miniprogram_platform_red_point" 
                    :style="{
                      border: show_theme_data.bg_color ? `2px solid ${show_theme_data.bg_color[0]}` : ''
                    }"
                  ></div>
                </div>
              </div>
              <AdvertiseDialog 
                v-if="showMiniProgramTip"
                class="mini-program-tip"
                router_link="/mini-program" 
                desc="最近使用、我的小程序、小程序平台<br/>都迁移到这里啦！"
                confirm_btn_text="来看看吧"
                :style="{maxWidth: '303px', top: '110px'}"
                :no_style="true"
                :no_report="true"
                @close="handleMiniProgramTipClose"
              ></AdvertiseDialog>
            </template>
            <div 
              v-for="tool in toolFunctionConfigs"
              :key="tool.key"
              class="cpt-shortcut-block-wrapper"
              v-remind-to-login="{cb:()=>{jumpToToolFunc(tool)}}"
            >
              <div
                class="tool-shortcuts shortcut-block circle" 
                :class="{
                  active: isToolActive(tool)
                }"
                v-tooltip="{
                  text: tool.availableFunc.length === 1 ? tool.availableFunc[0].name : tool.name,
                  placement: 'right',
                  popperClass: 'tooltip-roombar-text'
                }"
              >
                <img :src="tool.availableFunc.length === 1 ? tool.availableFunc[0].img : tool.img" :alt="tool.name" class="tool-img"/>
              </div>
            </div>
            <!-- 活动 -->
            <div
              v-for="(item, i) in act_list"
              :key="'activity' + i"
              class="cpt-shortcut-block-wrapper"
              :class="{'disabled': !is_login}"
              ref="act_list"
            >
              <div
                v-tooltip="{ 
                  text: item[activityPrefix + 'hover_text'], 
                  placement: 'right', 
                  popperClass: 'tooltip-roombar-text'
                }"
                class="shortcut-block"
                :class="{'active': $route.path === item.act_url}"
                :key="i"
                @click="activityShortCutClick(item)"
              >
                <ChatImgLazy :src="item.thumbnail" class="tool-img"></ChatImgLazy>
                <!-- <div class="red-count" v-if="activitityBoxCount">{{activitityBoxCount > 99 ? 99 : activitityBoxCount}}</div> -->
                <i
                  class="iconfont icon-link w-[18px] h-[18px] rounded-[9px] bg-fl-nv absolute bottom-[-4px] right-[-4px] flex-center"
                  :style="{
                    'background': show_theme_data.bar_color && show_theme_data.bar_color[0]
                  }"
                ></i>
              </div>
            </div>
          </div>

          <!-- 房间列表 -->
          <!-- <RoomShortCuts ref="room-short-cuts" @getFolderDone="getFolderDone" :isCompleted="isCompleted" /> -->
          <RoomShortCutsV2 ref="room-short-cuts" @getFolderDone="getFolderDone" :isCompleted="isCompleted" />

          <!-- 创建房间 -->
          <div
            class="cpt-shortcut-block-wrapper guide-wrapper add-room-wrapper w-full sticky mb-[-2px] bottom-[-1px] z-[103]"
            ref="sticky-wrapper"
            v-remind-to-login
            :style="`background: ${getBarColor}`"
          >
            <div class="shortcut-block" v-remind-to-login="{ cb: handleShowCreateRoom }" v-tooltip="{
              text: '创建房间',
              placement: 'right',
              popperClass: 'tooltip-roombar-text',
            }">
              <i class="iconfont icon-add-bold create-room"></i>
            </div>
            <Guide v-if="hasCreateRoomTask" guide_type="create_room" @show="showCreateRoomIcon = false">
              <div class="guide-create-room-btn">
                <PopingIcon :no_guide="true" :hidden="!showCreateRoomIcon" />
                <div class="trigger-click-area"></div>
              </div>
            </Guide>
          </div>

          <!-- 客户端下载 -->
          <div class="cpt-shortcut-block-wrapper" v-if="!isClient" id="left-sidebar-download-btn">
            <div class="shortcut-block" @click="downloadClient" v-tooltip="{
              text: '下载客户端',
              placement: 'right',
              popperClass: 'tooltip-roombar-text',
            }">
              <i class="iconfont icon-download-bold create-room"></i>
            </div>
          </div>

          <!-- 占位支撑 -->
          <div
            class="sticky w-[66px] bottom-[53px] left-0 h-[50px] pointer-events-none z-[104]"
            :class="{'opacity-0': !showStickyBackground}"
            :style="{
              background: show_theme_data.bar_color ? 
              `linear-gradient(${show_theme_data.bar_color[1]}00 0%, ${show_theme_data.bar_color[1]}ff 100%)` : 
              'linear-gradient(180deg, rgba(26, 28, 31, 0) 0%, var(--fill-navi) 100%)',
            }"
          ></div>
        </div>
        
        <SkeletonLeftSidebar 
          @showCreateRoomDialog="showCreateRoomDialog"
          v-if="isCompleted.some(item => !item)" />
        
          <transition :name="`float-${float_new_msg_data?.direction}`">
          <div
            v-if="float_new_msg_data"
            :key="float_new_msg_data.direction"
            :class="['float-room-button', `${float_new_msg_data.direction}-float-room`]"
            @click="handleScrollToRoom(float_new_msg_data.id, float_new_msg_data.direction)"
          >新消息</div>
        </transition>
      </div>
      <div class="icon" v-remind-to-login="{ cb:showConfig }">
        <i class="iconfont icon-set"></i>
      </div>
      <AdvertiseDialog 
        v-if="showAdvertiseDialog"
        :style="{ top: dialogTop + 'px' }" 
        :class="advertiseDialogConfig.classes"
        :img="advertiseDialogConfig.img"
        :link="advertiseDialogConfig.link" 
        :desc="advertiseDialogConfig.desc" 
        :confirm_btn_text="advertiseDialogConfig.confirm_btn_text"
        :no_style="advertiseDialogConfig.no_style"
        @close="showAdvertiseDialog = false"
      ></AdvertiseDialog>
    </div>
    
    <div class="layout-content-outer">
      <PermissionTempView v-if="showPermissionTempView" />
      <DnsTipBar v-else-if="show_dns_tip_bar" />
      <AnchorModeOpenTipBar v-else-if="showAnchorModeOpenTipBar"></AnchorModeOpenTipBar>
      <JoinRoomBanner v-else-if="showJoinRoomBanner" />
      <DownloadBanner 
        v-else-if="showDownloadBanner" 
        @close="(v) => SET_SETTING_DATA_PARAM({
          hide_download_banner: !v
        })" 
        :url="client_download_url" 
        @download_client="downloadClient" 
      />
      <div class="layout-content-wrapper">
        <div class="layout-bg-wrapper" v-if="themeBg || show_theme_data.bg_pic" :style="{
            'background-color': layoutBg,
          }">
          <div class="layout-bg" :style="{
            'background-image': themeBg,
            'opacity': (100 - show_theme_data.transparency) / 100,
            'filter': `blur(${show_theme_data.blur_rate / 100 * 60}px)`,
          }">
            <ChatImg 
              v-if="show_theme_data.bg_pic" 
              :src="show_theme_data.bg_pic" 
              :key="show_theme_data.bg_pic"
              :webp_quality="70"
              class="background-img"
              ></ChatImg>
          </div>
        </div>
        <div class="layout-content">
          <keep-alive include="team-center">
            <NetError v-if="init_net_error" />
            <router-view v-else></router-view>
          </keep-alive>
        </div>

        <div 
          v-if="showDragLine"
          class="split-drag-line" 
          @mousedown="startDragging($event, 'inner')" 
          :style="{
            background: show_theme_data.bar_color  ? `linear-gradient(180deg, ${show_theme_data.bar_color[0]} 0%, ${show_theme_data.bar_color[1]} 100%)` : ''
          }"
        >
          <div class="drag-border"></div>
        </div>

        <!-- <transition :name="show_right_bar_anmation ? 'sidebar' : ''"> -->
        <transition name="sidebar" @before-enter="beforeEnter">
          <div class="slider-friends" v-if="$route.meta.showFriendSideBar && show_friend_sidebar">
            <SidebarFriends 
              ref="slider-friends" 
              :style="{
                'background': (!show_page_style && cur_private_user.user_id) ? rightSidebarBg : '',
              }" 
            />
          </div>
          <div 
            v-else-if="right_bar_module === 'link'" 
            class="link-detail" 
            :style="{
              'width': linkStyle.width + 'px',
              'max-width': linkStyle.maxWidth + 'px',
              'background': (!show_page_style && cur_link) ? rightSidebarBg : '',
              'padding-top': (!show_page_style && cur_link) ? '0' : '51px'
            }"
          >
            <Post :linkStyle="linkStyle" :show_page_style="show_page_style"></Post>
          </div>
          <div 
            v-else-if="right_bar_module === 'reply'"
            class="link-detail" 
            :style="{
              'width': linkStyle.width + 'px',
              'max-width': linkStyle.maxWidth + 'px',
              'background': (!show_page_style && reply_list_params.msg_id) ? rightSidebarBg : '',
              'padding-top': (!show_page_style && reply_list_params.msg_id) ? '0' : '51px'
            }"
          >
            <ReplyList
              :key="repltListKey"
              :linkStyle="linkStyle"
              :show_page_style="show_page_style"
              :type="reply_list_params.is_resource_channel ? 'resource_reply' : 'reply'"
            />
          </div>

          <SidebarSearch
            v-else-if="right_bar_module === 'search'"
            :style="{'background': show_theme_data.bg_pic_main_color || themeBg}"
          />

          <!-- <RoomTeam
            v-else-if="right_bar_module === 'team'"
            :style="{'background': show_theme_data.bg_pic_main_color || themeBg}"
          /> -->
          <ChannelFeedback
            v-else-if="right_bar_module === 'feedback'"
            :style="{'background': show_theme_data.bg_pic_main_color || themeBg}"
          />
          <GroupChatMore
            v-else-if="right_bar_module === 'group'"
          />
        </transition>
      </div>
    </div>
    <transition name="fade">
      <ZoomToast v-if="show_center_zoom_toast" :window_zoom_factor="setting_data.window_zoom_factor" />
    </transition>
    

    <div 
      class="layout-private-im-wrapper h-full flex items-center"
      :key="cur_private_user.user_id || 'empty-private-im'"
      :style="privateStyles"
    >
      <div 
        v-if="showPrivateIM && show_page_style"
        class="split-drag-line" 
        @mousedown="startDragging($event, 'outer')" 
        :style="{
          background: show_theme_data.bar_color  ? `linear-gradient(180deg, ${show_theme_data.bar_color[0]} 0%, ${show_theme_data.bar_color[1]} 100%)` : ''
        }"
      >
        <div class="drag-border"></div>
      </div>
      <PrivateIM
        v-if="showPrivateIM"
        :show_page_style="true"
        :style="{
          'background': show_theme_data.bg_pic_main_color || themeBg || layoutBg || 'linear-gradient(180deg, var(--fill-input) 0%, var(--fill-1) 100%)',
          'width': privateImStyle.width + 'px',
          'max-width': privateImStyle.maxWidth + 'px'
        }" 
      />
    </div>

    <RoomTopBar
      v-if="$route.name === 'room' && !new_member_guider_config.show && !init_net_error"
      :style="roomTopBarStyle"
      :show_page_style="show_page_style"
      :channel_sidebar_width="initialWidth"
      :private_im_width="privateImStyle.width"
    />

    <ThemeManager 
      v-if="show_theme_manager" 
      :themeManagerData="themeManagerData" 
      :type="themeManagerData?.type" 
      @close="SET_SHOW_THEME_MANAGER(false)" 
    />

    <VoicePanel v-show="!new_member_guider_config.show && $route.meta.showVoicePanel && !init_net_error"></VoicePanel>

    <NoticeCenter></NoticeCenter>
    <PhoneMicConnect v-if="isClient" />

    <EmojiSelector
      v-if="isShowEmojiSelector"
      :init_data="emojiSelectorInitData"
      :lastTab.sync="emojiLastTab"
      ref="emoji-selector"
    />

    <ScreenShare 
      v-if="ifScreenShareDom" 
      v-show="showScreenShare" 
      :showScreenShareDom="showScreenShare"
      :imChannelId="cur_channel_data?.channel_id"
      @mouseenter.native="screenShareMouseEnter"
      @mouseleave.native="screenShareMouseLeave" 
      @mousemove.native="screenShareMouseOver"
    />

    <!-- 频道列表宽度拖拽线 -->
    <div 
      v-if="$route.name === 'room' && !new_member_guider_config.show && !show_bgm_selector && !init_net_error && !popover_show"
      class="channel-sidebar-drag-line absolute top-0 w-[4px] h-full bg-transparent cursor-col-resize hover:bg-op-2 transition-[background-color] z-[2000]"
      :style="dragLineStyle"
      @mousedown="startResizeChannelSideBar"
    />

    <DynamicComponent/>
    <DynamicDialog/>
    <UserCard 
      v-if="showUserCard"
      ref="user-card"
      :init_data="initUserCardData"
      @close="userCardHandler"
    />
    <OverlayPositionSetter v-if="showOverlayPositionSetter" :overlayPosition="overlayPosition" :setPath="overlayPositionSetPath" :customData="overlayPositionCustomData"/>
  </div>
</template>

<script>
const Post = () => import('@/views/room/PostChannel/Post/index.vue')
// const RoomTeam = () => import('@/views/room/Team/index.vue')
const ReplyList = () => import('@/views/room/IM/ReplyList/index.vue')

import VoicePanel from "_com/busy/VoicePanel";
const PrivateIM = () => import('@/components/IM/privateIM.vue')

import NoticeCenter from './components/notice/NoticeContainer.vue'
const PhoneMicConnect = () => import('./components/PhoneMicConnect.vue')
const AdvertiseDialog = () => import('./components/AdvertiseDialog.vue')
const FriendsGuideDialog = () => import('./components/FriendsGuideDialog.vue')

// import RoomShortCuts from "./components/RoomShortCuts.vue";
import RoomShortCutsV2 from "./components/room-short-cuts-v2/index.vue";

import SidebarFriends from "./components/SidebarFriends.vue";
const SidebarSearch = () => import("./components/channel-search/index.vue");
const ChannelFeedback = () => import("./components/channel-feedback/index.vue");
const MiniIMExpand = () => import("@/views/room/IM/AudioChannelBlock/components/MiniIMExpand.vue");

const AnchorModeOpenTipBar = () => import('./components/AnchorModeOpenTipBar.vue');
const DownloadBanner = () => import("./components/DownloadBanner.vue");
const JoinRoomBanner = () => import("./components/JoinRoomBanner.vue");
const PermissionTempView = () => import("./components/PermissionTempView.vue");
import SkeletonLeftSidebar from './components/Skeleton/SkeletonLeftSidebar.vue'

const MiniProgramContainer = () => import('./components/MiniProgramContainer.vue')
const EmojiSelector = () => import('_com/IM/EmojiSelector.vue');
const UserCard = () => import('_com/busy/UserCard/index.vue');
const ThemeManager = () => import('./components/theme-manager/ThemeManager.vue')

import DynamicComponent from './components/DynamicComponent.vue'

import DynamicDialog from '_com/dynamicComponent/DynamicDialog.vue'
import TitleBar from '_com/func/TitleBar.vue'

const ZoomToast = () => import('./components/ZoomToast.vue')

const PopingIcon = () => import("@/views/room/components/PopingIcon.vue");
const Guide = () => import("@/layout/components/guide/index.vue");
const OverlayPositionSetter = () => import('./components/OverlayPositionSetter.vue')
const RecentMiniprogram = () => import('./components/RecentMiniprogram.vue')
const ScreenShare = () => import('../views/room/IM/ScreenShare/ScreenShare.vue')
const DnsTipBar = () => import('./components/DnsTipBar.vue')
import RedNum from "_com/func/RedNum.vue";
const RoomTopBar = () => import('../views/room/components/topBar/index.vue')
const NetError = () => import('./components/NetError.vue')

import { throttle, checkLoginStatusAsync, addPageVisibilityChangeListener, setStorage, JSONParse, setCookie } from "_lib/utils/utils";
import { mapGetters, mapMutations, mapActions } from "vuex";
import webSocketInstance from "_lib/request/socket-standard";
import { listenClipboard } from "_lib/ClientClipboardListener"
import EventBus from '@/common/EventBus'
import Vue from 'vue';
import Cache from '_lib/DataCache'
import { getRoomAndChannelInfoByInviteCode } from '_api/invite'
import { getAuthInfo, getWsId, updateBilibiliLivingState } from '_api/account'
import { reportData, reportLogin } from '_api/report'
import { banUser } from "_api/room/index"
import { getAccDownloadUrl } from '_api/other'
import { getBoxCount } from '_api/boxActivity'
import { completeOnceTask, getOnceTasks } from '_api/task';
import { getLinkDetail, getLinkCommentList } from '_api/bbs/post'
import PostDataUtils from '@/views/room/PostChannel/Post/utils'
import { getAllRoomNotify, clearUnreadState } from "_api/notify";
import { getGlobalConfig } from "_api/other";
import { integrationAccount } from "_api/integration"
import { universalQuery, updateAccountSetting } from '_api/settings';
import { getIndexTask } from '_api/advertisement';
import { getSharePageInfo } from '_api/miniprogram';
import { getPostMsgUnread } from '_api/bbs';
import { getPkeyWithToken } from '_api/login'
import { voiceInviteToGlobalTeam, joinGlobalTeam } from '_api/global-team';
import { handleEnterRoom } from '_lib/EnterRoom';

import channelMixin from "_mixin/channel.js";
import overlayMixin from "_mixin/overlay.js";
import userMenuMixin from '_mixin/userMenu';
import ImScreenShare from "_mixin/ImScreenShare";
import channelHostHandlerMixin from "_mixin/channelHostHandler";

import { LAYOUT_WIDTH } from '@/common/constants/layout';
import { PARSE_LINK_TYPE } from '@/common/constants/IM.ts'
import { CHANNEL_TYPES } from '@/common/constants/channel';
import { TOOL_FUNCTION_CONFIG } from "@/common/constants/tool-function";
import { DEFAULT_ROOM_BG } from '@/common/constants/room';
import { ENTER_BY_INVITE_CODE_TYPES } from "_lib/constants/room";
import { FRIEND_CARD_BG } from "@/common/constants/user";
import { NEW_OFFICIAL_MESSAGE_ID } from '@/common/constants/message';
import { getOfficialMessageIds } from '@/common/utils/utilsFriend';
import { reportGameStatus } from "_api/game-status";
import { findChannel } from '_js/find-channel'
import { copyText, getStorage } from '_lib/utils/utils'
import { JUMP_ROOM_CHANNEL_EVENT } from "_lib/constants/global";
import { jumpRoomByCode } from "_lib/EnterRoom";
import { ADD_USER_BGM_SUFFIX } from '@/common/constants/rtc'
import { ONCE_TASK_TYPES } from "@/common/constants/tasks";
import { checkIsResourceChannel } from '@/views/room/utils';
import { startMatch } from '_api/team-match'
import { enterGroupChat } from '_lib/utils/utilsGroup';
import { handleDeleteFriend } from '_lib/utils/utilsFriend';
import channelSidebarResizeMixin from "@/views/room/components/mixin/channelSidebarResize";
import recentMsgContextMenuMixin from '@/mixin/recentMsgContextMenu'
import { handleEnterGlobalTeam } from '@/views/room/utils';
const GroupChatMore = () => import('./components/GroupChatMore/index.vue');
const TITLE_BAR_CLASS = "cpt-electron-title-bar"

// 默认切换右边栏展示模式的宽度
const DEFAULT_SWITCH_WIDTH = 1680

export default {
  mixins: [
    channelMixin, 
    overlayMixin, 
    userMenuMixin,
    ImScreenShare,
    channelSidebarResizeMixin,
    channelHostHandlerMixin,
    recentMsgContextMenuMixin,
  ],
  components: {
    Post,
    // RoomTeam,
    ReplyList,
    VoicePanel,
    NoticeCenter,
    PhoneMicConnect,
    AdvertiseDialog,
    FriendsGuideDialog,
    PrivateIM,
    SidebarFriends,
    SidebarSearch,
    ChannelFeedback,
    DownloadBanner,
    JoinRoomBanner,
    PermissionTempView,
    SkeletonLeftSidebar,
    EmojiSelector,
    ThemeManager,
    DynamicComponent,
    DynamicDialog,
    ZoomToast,
    UserCard,
    AnchorModeOpenTipBar,
    MiniProgramContainer,
    // RoomShortCuts,
    RoomShortCutsV2,
    PopingIcon,
    Guide,
    OverlayPositionSetter,
    RecentMiniprogram,
    ScreenShare,
    DnsTipBar,
    RedNum,
    MiniIMExpand,
    RoomTopBar,
    GroupChatMore,
    NetError,
  },
  data() {
    return {
      showInviteSelectRoom: true,
      toolFunctionConfigs: [],
      isCompleted: [false, false, false, false],
      roomList: [],
      activitityBoxCount: 0,
      window_width: window.innerWidth,
      dragging: false,
      startX: 0,
      containerWidth: 0, // 容器宽度
      is_draged: false,
      show_page_style: false,
      handleResizeListener: null,
      themeManagerData: null,
      isShowEmojiSelector: false,
      emojiSelectorInitData: {},
      emojiLastTab: 'emojis',
      showAdvertiseDialog: false,
      dialogTop: 0,
      advertiseDialogConfig: {
        name: '',
        img: '',
        link: '',
        desc: '',
        confirm_btn_text: '',
        no_style: false,
        classes: ''
      },
      shortcutsScrollListener: null,
      stickyScrollListener: null,
      friendsMsgStickyListener: null,
      resizeObserver: null,
      topRoomId: '',
      bottomRoomId: '',
      show_center_zoom_toast: false,
      privateImStyle: {
        width: 450,
        maxWidth: 450
      },
      linkStyle: {
        defaultWidth: Math.max(450, Math.round(window.innerWidth / 3)),
        width: 450,
        maxWidth: 450
      },

      showLoginDialog: false,
      showUserCard: false,
      initUserCardData: {},
      showBodyBanner: false,
      jumpRoomByCode,
      get_index_task_timer: null,
      repltListKey: 0,
      chatIconHover: false,

      showCreateRoomIcon: true,
      showStickyBackground: false,
      showFriendsMsgSticky: false,

      showOverlayPositionSetter: false,
      overlayPosition: {
        top: 0,
        left: 0,
      },
      overlayPositionSetPath: '',
      overlayPositionSetterCloseCb: null,
      overlayPositionCustomData: null,
      showMiniProgramTip: false,
      showFriendsCenterTip: false,

      draggingLineName: '',
    }
  },
  created() {
    this.linkStyle.width = this.linkStyle.maxWidth = this.linkStyle.defaultWidth
    this.handleResizeListener = throttle(this.getPageWidth, 50)
    this.shortcutsScrollListener = throttle(this.handleShortcutsScroll, 500)
    this.stickyScrollListener = throttle(this.handleStickyScroll, 50)
    this.friendsMsgStickyListener = throttle(this.handleFriendsMsgSticky, 50)
    this.reportExposure()
    this.initIntegrarionAxios()
    this.receiveGamingName()
    this.receiveTrayMsgClick()
    this.getPhoneNumInfo();
    this.initGameFunctions();
    this.loadImgs();
    this.onElectronStoreError();
    this.initGlobalConfig();
    this.watchPageThemeMedia()

    listenClipboard()
  }, 
  mounted() {
    this.initWebSocket();
    this.initHandler() 
    EventBus.$on('Connect_Error', this.handleConnectError)
    // 更新个人在线状态推送
    EventBus.$on('SOCKET_UPDATE_MY_ONLINE_STATE', this.updateMyOnlineState)
    EventBus.$on('Add_Steam_Friend', this.handleAddSteamFriend);
    EventBus.$on('Update_Phonenum', this.getPhoneNumInfo);
    EventBus.$on('Show_Private_IM', this.handlePrivateIm);
    EventBus.$on('Show_Chat_Group_IM', this.handleChatGroupIm);
    EventBus.$on('Hide_Private_IM', this.handlePrivateImHide);
    EventBus.$on('Hide_Chat_Group_IM', this.handleHideChatGroupIm);
    EventBus.$on('User_Menu:contextmenu', this.userContextMenuHandler);
    EventBus.$on('User_Menu:private', this.privateChatHandlerV2);
    EventBus.$on('Show_Theme_Manager', this.showThemeManagerHandler);
    EventBus.$on('SOCKET_USER_CHANNEL_MOVE', this.moveCurChannel);
    EventBus.$on('Join_By_Invite_Code', this.jumpRoomByCode);
    EventBus.$on('Download_Client', this.downloadClient);
    // 显示下载提示弹窗
    EventBus.$on('Show_Download_Client_Dialog', this.handleShowDownloadClientDialog);
    EventBus.$on('Show_Emoji_Selector', this.handleShowEmojiSelector)
    EventBus.$on('CancelBanUser', this.handleCancelBanUser)
    EventBus.$on('Get_Once_Tasks', this.getOnceTasks)
    // ws重连时用户游戏状态会被情况，需要重新上报
    EventBus.$on('Socket_Connect', this.reconnectReport)
    EventBus.$on('CheckRoomMsgPosition', this.handleShortcutsScroll)
    EventBus.$on('ScrollRoomBarToCenter', this.handleScrollToRoom)
    // 帖子
    EventBus.$on('ShowLinkDetail', this.showLinkDetail)
    EventBus.$on('HideLinkDetail', this.hideLinkDetail)
    EventBus.$on('ShowReplyList', this.handleShowReplyList)
    EventBus.$on('HideReplyList', this.handleHideReplyList)
    EventBus.$on('User_Menu:card', this.userCardHandler);
    EventBus.$on('initUnreadStateCache', this.handleInitUnreadStateCache)
    EventBus.$on('RichMessageLinkClick', this.handleRichMessageLinkClick)

    // 房间频道进入处理函数
    EventBus.$on(JUMP_ROOM_CHANNEL_EVENT, this.jumpRoomChannel)
    EventBus.$on('Change_Overlay_Position_Setter_Show', this.handleChangeOverlayPositionSetterShow)

    // 处理ElectronTitleBar隐藏
    EventBus.$on('Change_Electron_Title_Bar_Show', this.handleShowElectronTitleBar)
    EventBus.$on('Delete_friend', this.handleDelFriend)
    EventBus.$on('Change_Emoji_Selector_Mouse_Enter', this.handleChangeEmojiSelectorMouseEnter)

    // 获取布局宽度
    EventBus.$on('Get_Layout_Width', this.handleGetLayoutWidth)
    
    // 通用Query弹窗
    EventBus.$on('SOCKET_UNIVERSAL_POPUP', this.handleShowUniversalQuery)

    // 1.53.0版本开放组队大厅入口
    // EventBus.$on('GlobalTeam:handleVoiceInvite', this.handleTeamVoiceInvite);
    // EventBus.$on('GlobalTeam:joinTeamAudio', this.handleJoinTeamAudio);

    this.getPageWidth()
    window.addEventListener('resize', this.getPageWidth);
    // 处理视窗缩放变化
    window.addEventListener('zoom', this.getPageWidth)
    window.addEventListener('focus', this.windowFocus)
    window.addEventListener('blur', this.windowBlur)
    if(window.client_env !== 'electron') {
      window.addEventListener('beforeunload', this.confirmExit);
    } else {
      window.electronAPI.sendRendererReady();
      
      window.electronAPI.getStartup().then((startup) => {
        if (startup) {
          let d = startup.split(',')
          setTimeout(() => {
            let jumpData = {
              room_id: d[0]
            }
            if (d[1]) {
              jumpData.channel_id = d[1]
            }
            this.jumpRoomChannel(jumpData)
          }, 300)
        }
      })
      
      window.electronAPI.onShowInviteSend((_, invite_code, web_token) => {
        // 如果有web_token且用户未登录，先尝试使用web_token登录
        if (web_token && !this.user_info.user_id) {
          this.handleWebTokenLogin(web_token, invite_code)
        }

        getRoomAndChannelInfoByInviteCode({
          invite_code,
          _notip: true,
        }).then(({ data: { status, result: { info } } }) => {
          if (status == 'ok') {
            // 用户已登陆并且拥有该房间
            const { access } = info
            if(access){
              let { channel_id, channel_type, room_id } = info
              if (channel_id && CHANNEL_TYPES.has_audio_types.includes(channel_type) && this.cur_channel_data.channel_id !== channel_id) {
                setStorage("await_enter_channel", {
                  channel_id,
                  from_web_invite: true,
                });
                if (this.cur_room_data.room_id !== room_id) {
                  channel_id = undefined
                }
              }
              this.jumpRoomChannel({
                channel_id,
                room_id,
              })
            } else {
              EventBus.$dynamic('InvitedDialog', {invite_code})
            }
          }
        }).catch(() => {
          EventBus.$dynamic('InvitedDialog', {invite_code})
        })
        
      })
      this.initMiniProSetting()
    }
    this.reportSystemVersion()
    this.reloginAppend()
    this.initWindowShowListener()
    this.initZoomToast()
    this.initTitleBar()
    this.initObsListener()
    this.initElectronShowToast()
    this.initListenCs2InjectNotice()
    this.initUpdateTrayMenuData()
    this.initElectronCallQueryDialog()
    this.initElectronExitApp()

    if(this.$route.query.bot_id) {
      EventBus.$dynamic('BotInviteDialog', { botId: this.$route.query.bot_id })
    }
    if(this.$route.query.mini_pro_id) {
      this.handleStartMiniProgram()   
    }
    

    document.documentElement.style.fontSize = (this.setting_data.msg_font_size / 14) * 100 + '%'
    this.$refs['shortcuts-scroller'].addEventListener('scroll', this.shortcutsScrollListener, { passive: true })
    this.$refs['shortcuts-scroller'].addEventListener('scroll', this.stickyScrollListener, { passive: true })
    this.$refs['shortcuts-scroller'].addEventListener('scroll', this.friendsMsgStickyListener, { passive: true })

    this.checkRouteData()

    this.initAddRoomSticky()

  },
  beforeDestroy() {
    webSocketInstance.closeWebSocket()
    EventBus.$off('Connect_Error', this.handleConnectError)
    EventBus.$off('SOCKET_UPDATE_MY_ONLINE_STATE', this.updateMyOnlineState)
    EventBus.$off('Add_Steam_Friend', this.handleAddSteamFriend);
    EventBus.$off('Update_Phonenum', this.getPhoneNumInfo);
    EventBus.$off('Show_Private_IM', this.handlePrivateIm);
    EventBus.$off('Show_Chat_Group_IM', this.handleChatGroupIm);
    EventBus.$off('Hide_Private_IM', this.handlePrivateImHide);
    EventBus.$off('Hide_Chat_Group_IM', this.handleHideChatGroupIm);
    EventBus.$off('User_Menu:contextmenu', this.userContextMenuHandler);
    EventBus.$off('User_Menu:private', this.privateChatHandlerV2);
    EventBus.$off('Show_Theme_Manager', this.showThemeManagerHandler);
    EventBus.$off('SOCKET_USER_CHANNEL_MOVE', this.moveCurChannel);
    EventBus.$off('Join_By_Invite_Code', this.jumpRoomByCode);
    EventBus.$off('Download_Client', this.downloadClient);
    EventBus.$off('Show_Download_Client_Dialog', this.handleShowDownloadClientDialog);
    EventBus.$off('Show_Emoji_Selector', this.handleShowEmojiSelector)
    EventBus.$off('CancelBanUser', this.handleCancelBanUser)
    EventBus.$off('Get_Once_Tasks', this.getOnceTasks)
    EventBus.$off('Socket_Connect', this.reconnectReport)
    EventBus.$off('CheckRoomMsgPosition', this.handleShortcutsScroll)
    EventBus.$off('ScrollRoomBarToCenter', this.handleScrollToRoom)
    EventBus.$off('ShowLinkDetail', this.showLinkDetail)
    EventBus.$off('HideLinkDetail', this.hideLinkDetail)
    EventBus.$off('ShowReplyList', this.handleShowReplyList)
    EventBus.$off('HideReplyList', this.handleHideReplyList)
    EventBus.$off('User_Menu:card', this.userCardHandler);
    EventBus.$off('initUnreadStateCache', this.handleInitUnreadStateCache)
    EventBus.$off('RichMessageLinkClick', this.handleRichMessageLinkClick)
    EventBus.$off(JUMP_ROOM_CHANNEL_EVENT, this.jumpRoomChannel)
    EventBus.$off('Change_Overlay_Position_Setter_Show', this.handleChangeOverlayPositionSetterShow)
    EventBus.$off('Change_Electron_Title_Bar_Show', this.handleShowElectronTitleBar)
    EventBus.$off('Delete_friend', this.handleDelFriend)
    EventBus.$off('Change_Emoji_Selector_Mouse_Enter', this.handleChangeEmojiSelectorMouseEnter)
    // 获取布局宽度
    EventBus.$off('Get_Layout_Width', this.handleGetLayoutWidth)
    // EventBus.$off('GlobalTeam:handleVoiceInvite', this.handleTeamVoiceInvite);
    // EventBus.$off('GlobalTeam:joinTeamAudio', this.handleJoinTeamAudio);
    clearTimeout(this._getBoxCountTimeout)
    clearTimeout(this._show_center_zoom_toast_timer)

    this.removeBanner()
    window.removeEventListener('resize', this.getPageWidth);
    window.removeEventListener('zoom', this.getPageWidth);
    window.removeEventListener('focus', this.windowFocus)
    window.removeEventListener('blur', this.windowBlur)
    window.removeEventListener('beforeunload', this.confirmExit);
    this.$refs['shortcuts-scroller'].removeEventListener('scroll', this.shortcutsScrollListener)
    this.$refs['shortcuts-scroller'].removeEventListener('scroll', this.stickyScrollListener)
    this.$refs['shortcuts-scroller'].removeEventListener('scroll', this.friendsMsgStickyListener)
    
    clearTimeout(this.get_index_task_timer)
    clearTimeout(this._unreadMsgTimer)

    this.destroyAddRoomSticky()
  },
  computed: {
    layoutWidthAbout() {
      return {
        window_width: this.window_width,
        channel_sidebar_width: this.initialWidth,
        show_page_style: this.show_page_style,
        private_im_width: this.privateImStyle.width,
      }
    },
    showPermissionTempView () {
      return this.temp_role_data.temp_role && this.temp_role_data.temp_role.id && this.temp_role_data.room_id == this.cur_room_data.room_id
    },
    activityPrefix() {
      return process.env.IS_CLIENT ? 'client_' : 'web_'
    },
    showDownload() {
      // 仅首页展示下载banner
      let loginedShowBanner = this.$route.meta.showDownloadBanners 
        && !this.hide_download_banner 
        && this.$route.name === 'home' 
        && this.client_download_url 
        && window.client_env !== 'electron'
      // 如果showBodyBanner，需要展示banner占位
      return this.showBodyBanner || loginedShowBanner
    },
    isOfficialMsg () {
      return this.cur_private_user.user_id === NEW_OFFICIAL_MESSAGE_ID.heychat_sys_notify
    },
    themeBg() {
      return this.show_theme_data.bg_color 
        ? `linear-gradient(180deg, ${this.show_theme_data.bg_color[0]} 0%, ${this.show_theme_data.bg_color[1]} 50%, ${this.show_theme_data.bg_color[1]} 100%)` 
        : ''
    },
    layoutBg() {
      if (this.show_theme_data.bg_pic && this.show_theme_data.bg_pic_main_color) {
        return this.show_theme_data.bg_pic_main_color
      } else {
        return ''
      }
    },
    hasUnreadMsgRooms() {
      const rooms = this.room_list.filter(room => {
        const unread = this.$unread.getUnreadState({room_id: room.room_id})
        return unread && unread.redCount > 0
      })
      return rooms.map(item => {
        return {
          room_id: item.room_id,
          folder_id: item.folder_id
        }
      })
    },
    float_new_msg_data () {
      if (this.bottomRoomId && this.cur_room_data.room_id != this.bottomRoomId) {
        return {
          direction: 'bottom',
          id: this.bottomRoomId
        }
      } else if (this.topRoomId && this.cur_room_data.room_id != this.topRoomId) {
        return {
          direction: 'top',
          id: this.topRoomId
        }
      }
    },
    showPrivateIM() {
      return !!this.cur_private_user.user_id && this.$route.name === 'room'
    },
    showDragLine () {
      return this.show_page_style && (this.cur_link || this.reply_list_params.msg_id)
    },
    getBarColor() {
      if (!this.showStickyBackground) return '';
      if (this.show_theme_data && this.show_theme_data.bar_color) {
        return this.show_theme_data.bar_color[1]
      }
      return 'var(--fill-navi)'
    },
    hasCreateRoomTask() {
      return this.show_once_task_by_id(ONCE_TASK_TYPES.create_room);
    },
    showScreenShare() {
      if(this.host_mode) {
        return this.showScreenShareDom && this.is_show_screen_sharing(this.cur_channel_data.channel_id)
      } else {
        return this.showScreenShareDom
      }
    },
    privateStyles() {
      if(!this.showPrivateIM) {
        return {}
      }

      const DRAG_LINE_WIDTH = 10
      if(!this.show_page_style) {
        return {
          width: this.privateImStyle.width + 'px',
          'max-width': this.privateImStyle.width + 'px',
          'right': '0',
          'left': 'auto',
          'box-shadow': '-12px 0px 24px 0px rgba(0, 0, 0, 0.25)',
          'background-image': 'var(--d-bg-ln-1)',
          'position': 'absolute',
        }
      } else {
        return {
          width: 'fit-content',
          'max-width': this.privateImStyle.maxWidth + DRAG_LINE_WIDTH + 'px',
          'position': 'static',
        }
      }
    },
    showAnchorModeOpenTipBar() {
      return this.anchor_mode 
          && !this.hide_anchor_mode_tip_bar 
          && this.cur_channel_data.channel_id
          && this.cur_channel_data.room_id === this.cur_room_data.room_id
    },
    showJoinRoomBanner() {
      return this.cur_room_data.room_id && (this.cur_room_data_is_visitor || !this.is_login)
    },
    showDownloadBanner() {
      return !this.showPermissionTempView && this.showDownload
    },
    roomTopBarStyle() {
      const shouldMove =
        this.showPermissionTempView ||
        this.show_dns_tip_bar ||
        this.showAnchorModeOpenTipBar ||
        this.showJoinRoomBanner ||
        this.showDownloadBanner;

      return {
        top: shouldMove ? '40px' : '0'
      };
    },
    rightSidebarBg() {
      return this.show_theme_data.bg_pic_main_color || this.themeBg || this.layoutBg || 'linear-gradient(180deg, var(--fill-input) 0%, var(--fill-1) 100%)'
    },
    ...mapGetters([
      "user_info", 
      'is_login',
      'online_state',
      'cur_channel_data', 
      'channel_data',
      'cur_room_data',
      'ws_id', 
      'client_download_url', 
      'channel_connecting',
      'cur_private_user',
      'hide_download_banner',
      'temp_role_data',
      'show_friend_sidebar',
      'show_right_bar_anmation',
      'right_bar_module',
      'room_list',
      'last_private_im_width',
      'act_list',
      'is_act_intime',
      'show_theme_data',
      'show_theme_manager',
      'recent_msg_list',
      'all_unread_states',
      'page_theme',
      'bar_theme',
      'cur_link',
      'anchor_mode',
      'hide_anchor_mode_tip_bar',
      'new_member_guider_config',
      'bilibili_living',
      'laughter_flatten_list',
      'global_check_bilibili',
      'reply_list_params',
      'cur_link_from',
      'all_notify_settings',
      "show_once_task_by_id",
      'miniprogram_setting',
      'cur_room_whole_data',
      'show_dns_tip_bar',
      'is_matching',
      'match_params',
      'cur_room_data_is_visitor',
      'is_init_laughter_tracks',
      'is_show_screen_sharing',,
      'user_account_settings',
      'recent_msg_count',
      'showAddFriendModal',
      'last_show_friend_sidebar',
      'show_bgm_selector',
      'friends_map',
      'cur_group_chat',
      'global_team_setting',
      'cur_global_team',
      'init_net_error',
    ]),
  },
  watch: {
    right_bar_module (v) {
      this.getDrawerMaxWidth()
    },
    $route: {
      handler (to, from) {
        if(from?.name === 'friend' && this.right_bar_module === 'group') {
          this.SET_SHOW_RIGHT_BAR_MODULE('')
          return
        }
        if (to?.meta?.hiddenPrivateChat) {
          this.handleUpdatePageStyle(false)
          this.handlePrivateImHide()
        }
        if(to?.name !== 'home') {
          this.removeBanner()
        } else {
          // this.SET_SHOW_RIGHT_BAR_MODULE('')
        }
        if(to?.name === 'room' && this.last_show_friend_sidebar) {
          this.SET_SHOW_FRIEND_SIDEBAR(true)
        }
      },
    },
    'room_list': {
      handler(v, oldv) {
        // 有新增房间，重新请求通知列表
        if (v.length > oldv.length) {
          this.getAllRoomNotify()
        }
      },
    },
    hasUnreadMsgRooms() {
      clearTimeout(this._unreadMsgTimer)
      this._unreadMsgTimer = setTimeout(() => {
        this.handleShortcutsScroll()
      })
    },
    page_theme(v) {
      this.updaPageTheme()
    },
    'show_theme_data.bar_color': {
      handler(v) {
        document.body.style.background = this.show_theme_data.bar_color 
          ? `linear-gradient(180deg, ${this.show_theme_data.bar_color[0]} 0%, ${this.show_theme_data.bar_color[1]} 100%)` 
          : '';
        const appEl = document.querySelector('#app')
        if (appEl) {
          if (this.show_theme_data.bar_color && this.show_theme_data.bar_color[0]) {
            appEl.style.setProperty('--show-theme-color', this.show_theme_data.bar_color[0])
          } else {
            appEl.style.setProperty('--show-theme-color', 'var(--fill-navi)')
          }
        }
      },
    },
    'setting_data.isOpenLaughterRoulette': {
      handler(v) {
        this.enableLaughterRoulette(v)
      },
      immediate: true,
    },
    showAddFriendModal (v) {
      if (v) {
        EventBus.$dynamic('AddFriendDialog')
      } else {
        EventBus.$emit('hide-dynamic-dialog', 'AddFriendDialog')
      }
    },
    layoutWidthAbout() {
      EventBus.$emit('Layout_Width_Changed', this.layoutWidthAbout)
    },
  },
  methods: {
    // electron通知web发送data & 通知web更新数据
    initUpdateTrayMenuData () {
      if(process.env.IS_CLIENT) {
        window.electronAPI.getTrayContextMenuData((_) => {
          const data = {
            onlineState: this.online_state,
            display_current_playing_game: this.user_info.display_current_playing_game,
            display_current_music: this.user_info.display_current_music,
            show_in_room_state: this.user_info.show_in_room_state,
            is_tray_flash: this.setting_data.is_tray_flash,
            new_message_sound: this.setting_data.tip_sound_control[0],
          }
          window.electronAPI.setTrayContextMenuData(data)
        })
        
        window.electronAPI.onUpdateTrayContextMenuData((_event, data) => {
          const { key, sub_key, value } = data
          switch (key) {
            case 'onlineState':
              this.SET_ONLINESTATE(value)
              this.updateUserAccountSetting('online_state', value)
              break
            case 'status_privacy':
              this.SET_USER_INFO({
                [sub_key]: value,
              })
              this.updateUserAccountSetting(sub_key, value ? 1 : 0)
              break
            case 'is_tray_flash':
              this.SET_SETTING_DATA_PARAM({
                is_tray_flash: value
              })
              break
            case 'new_message_sound':
              const tip_sound_control = this.setting_data.tip_sound_control || []
              tip_sound_control.splice(0, 1, !tip_sound_control[0])
              this.SET_SETTING_DATA_PARAM({
                tip_sound_control
              })
              break
          }
        })
      }
    },
    updateUserAccountSetting (key, value) {
      this.SET_USER_ACCOUNT_SETTINGS({
        [key]: value
      })
      updateAccountSetting({}, {
        setting: key,
        value: value
      })
    },
    beforeEnter(el) {
      if (!this.show_right_bar_anmation) {
        el.style.transition = 'none';
      }
    },
    async cancelMatch() {
      if(this.is_matching) {
        await startMatch({}, {
          ...this.match_params,
          is_start: false
        })
      }
    },
    handleMiniProgramTipClose () {
      this.SET_SETTING_DATA_PARAM({
        show_mini_program_tip: true
      })
      this.showMiniProgramTip = false
    },
    handleFriendsCenterTipClose () {
      this.SET_SETTING_DATA_PARAM({
        show_friends_center_tip: true
      })
      this.showFriendsCenterTip = false
      this.$nextTick(() => {
        if (!this.setting_data.show_mini_program_tip) {
          this.showMiniProgramTip = true
        }
      })
    },
    handleConnectError(type) {
      if (type == 'relogin') {
        EventBus.$emit('Channel_Access:exitChannel');
        this.$query({
          config: {
            title: '账号异常',
            desc: '账号被踢出, 请刷新页面',
            confirm: {
              text: '确认',
            },
            disableClose: true,
          },
          confirmCB: () => {
            window.location.reload()
          },
        })
      } else if (type == 'ws_disconnect') {
        // 如果初始化未完成，则设置网络错误
        if (this.isCompleted.some((v) => !v)) {
          this.SET_INIT_NET_ERROR(true)
        } else {
          EventBus.$dynamic('WsReconnect')
          let func = () => {
            EventBus.$off('Socket_Connect', func)
            EventBus.$emit('hide-dynamic-dialog', 'WsReconnect')
          }
          EventBus.$on('Socket_Connect', func)
        }
      }
    },
    async confirmExit(event) {
      if(this.is_matching) {
        event.returnValue = '您确定要离开此页面吗？'
        event.preventDefault()
        await this.cancelMatch()
        return event.returnValue
      }
      if((process.env.IS_PROD || process.env.IS_TEST) && this.cur_channel_data.channel_id) {
        event.returnValue = '您确定要离开此页面吗？'
        event.preventDefault()
        return event.returnValue
      }
    },
    userCardHandler(event, type, user, { key, offset = 0, mouseenterCb, mouseleaveCb, origin } = {}) {
      if (event === false) {
        this.showUserCard = false
        this.SET_ACTIVE_USER_CARD('')
        this.initUserCardData = {}
        return
      }
      if (!user?.user_id) {
        return
      }
      user.user_id = Number(user.user_id)
      if (getOfficialMessageIds().includes(user.user_id)) {
        return
      }
      origin = origin !== undefined ? origin: this.$route.name === 'room'
      this.initUserCardData = {
        event,
        type,
        user,
        key,
        offset,
        mouseenterCb,
        mouseleaveCb,
        origin,
      }
      if (this.showUserCard && this.$refs['user-card']) {
        this.$refs['user-card'].userCardMenuHandler(this.initUserCardData)
      }
      this.showUserCard = true
    },
    async showLinkDetail (link_id, index, link_type, root_comment_id, is_game_comment) {
      if (this.cur_link && (this.cur_link.lock || (this.cur_link.link_id === link_id))) {
        this.SET_SHOW_RIGHT_BAR_MODULE('link')
        return
      }
      
      this.handleUpdatePageStyle()
      
      // 设置 cur_link，包含预处理的数据
      this.SET_CUR_LINK({
        link_id,
        index,
        link_type,
        root_comment_id,
        is_game_comment,
      })
      this.SET_SHOW_RIGHT_BAR_MODULE('link')
    },
    hideLinkDetail () {
      this.SET_CUR_LINK(null)
      // if (this.cur_link_from.type === 'msg') {
      //   this.$nextTick(() => {
      //     const user = this.recent_msg_list.find(item => item.user_id == this.cur_link_from.user_id)
      //     user && this.handlePrivateIm(user, true, true)
      //   })
      // }
      this.SET_SHOW_RIGHT_BAR_MODULE('')
    },
    handleShowReplyList (params) {
      this.handleUpdatePageStyle()
      this.SET_REPLY_LIST_PARAMS(params)
      this.SET_SHOW_RIGHT_BAR_MODULE('reply')
      this.repltListKey++
    },
    handleHideReplyList () {
      this.SET_REPLY_LIST_PARAMS({})
      this.SET_SHOW_RIGHT_BAR_MODULE('')
    },
    initIndexTask() {
      clearTimeout(this.get_index_task_timer)
      getIndexTask({_notip: true}).then(res => {
        if (res.data.status === 'ok') {
          let result = res.data.result
          this.SET_INDEX_TASK(result.index_task)
        }
      })
      this.get_index_task_timer = setTimeout(() => {
        this.initIndexTask()
      }, 300000)
    },
    initIntegrarionAxios() {
      integrationAccount({_notip: true}).then(res => {
        if (res.data.status === 'ok') {
          let result = res.data.result
          this.SET_BLACKLIST(result.black_list.map(item=>item.user_id))
          this.SET_INVISIBLELIST(result.cannot_view.map(item=>item.user_id))

          const account_setting = result.account_setting
          account_setting.show_decoration = result.show_decoration
          account_setting.miniprogram_platform_red_point = result.miniprogram_platform_red_point
          this.setAccountSetting(account_setting)
          this.SET_ONCE_TASK_LIST(result.once_tasks)
          this.SET_USER_THEME_SETTING(result.decoration)
          this.SET_ANCHOR_WHITE_LIST(result.anchor_white_list)
          this.SET_AVATAR_MAIN_COLOR(result.avatar_main_color)
          this.SET_LAUGHTER_BLACKLIST(result.voice_pack_black_list)
          this.SET_RECENT_MINI_PRO(result.recent_mini_pro || [])
          this.SET_USER_VERIFIED_STATUS(result.verify_status ?? {})
          this.$set(this.isCompleted, 1, true)

          let talk_list_unread_count = result.talk_list_unread_count || 0

          getPostMsgUnread().then(postMsgUnreadRes => {
            if (postMsgUnreadRes.data.status === 'ok') {
              let postMsgUnreadResult = postMsgUnreadRes.data.result
              let post_msg_unread = {
                award: 0,
                comment: 0,
                at: 0,
              }
              if(account_setting.push_interaction_msg) { 
                post_msg_unread = {
                  award: postMsgUnreadResult.award,
                  comment: postMsgUnreadResult.comment,
                  at: postMsgUnreadResult.at,
                }
                talk_list_unread_count += post_msg_unread.award + post_msg_unread.comment + post_msg_unread.at
                this.SET_POST_MSG_UNREAD(post_msg_unread)
              }
            }
          }).finally(() => {
            this.SET_RECENT_MSG_COUNT(talk_list_unread_count)
          })

          

          // 判断是否在活动时间内
          let act_list = result.act_list.filter((_) => this.is_act_intime(_))
          this.SET_ACT_LIST(act_list)
          if (act_list && act_list.length > 0) {
            let item = act_list[act_list.length - 1]
            this.advertiseDialogConfig = {
              name: item.act_name,
              img: item.img,
              link: item.act_url,
              desc: item[this.activityPrefix + 'display_text'],
              confirm_btn_text: item.btn_text ? item.btn_text : undefined,
              no_style: false,
              classes: ''
            }
            if (result.popover) {
              this.handleshowAdvertiseDialog()
            }
          }

          if (!process.env.IS_CLIENT) {
            this.SET_BILIBILI_LIVING(result.bilibilier)
          }
        } else {
          EventBus.$emit('Get_Update_Url')
        }
      }).finally(()=>{
          this.$set(this.isCompleted, 1, true)
      })
    },
    // 展示活动弹窗
    handleshowAdvertiseDialog() {
      let showFunc = () => {
        this.$nextTick(() => {
          let list = this.$refs['act_list']
          let dom = list[list.length - 1]
          let rect = dom.getBoundingClientRect()
          
          this.dialogTop = rect.top - 30
          this.showAdvertiseDialog = true
        })
      }
      if (this.isCompleted.every(item=>item)) {
        // 如果左侧列表全部加载完成，直接执行展示函数
        showFunc()
      } else {
        // 如果列表未加载完成，watch isCompleted数组，全部为true后执行展示函数
        this.showAdvertiseDialogWatcher = this.$watch('isCompleted', function (newVal) {
          if (newVal.every(item=>item)) {
            showFunc()
            // unwatch showAdvertiseDialogWatcher
            this.showAdvertiseDialogWatcher && this.showAdvertiseDialogWatcher()
          }
        })
      }
    },
    initHandler() {
      // 未读消息处理
      import('_lib/UnreadMsgHandler.js').then(({ default: UnreadMsgHandler }) => {
        new UnreadMsgHandler()
      })
      // 消息缓存处理
      import('_lib/MsgCacheHandler.js').then(({ default: MsgCacheHandler }) => {
        new MsgCacheHandler()
      })
      // 房间缓存处理
      import('_lib/RoomCacheHandler.js').then(({ default: RoomCacheHandler }) => {
        new RoomCacheHandler()
      })
      // 频道通知设置处理
      import('_lib/ChannelNotifySettingHandler.js').then(({ default: ChannelNotifySettingHandler }) => {
        new ChannelNotifySettingHandler()
      })
    },
    getRightBarModuleWidth() {
      if(this.right_bar_module === 'search') {
        return LAYOUT_WIDTH.SEARCH_BAR
      } else if(this.show_friend_sidebar) {
        return LAYOUT_WIDTH.FRIEND_LIST
      } else {
        return 0
      }
    },
    getDrawerMaxWidth () {
      // 66: left-sidebar-layout; 
      // 240: channel-sidebar; 
      // 450: IM的min-width; 
      // 10: split-drag-line;
      // 280: sidebar
      const channel_sidebar_width = this.initialWidth
      if (this.cur_private_user.user_id) {
        const chat_max_width = window.innerWidth - LAYOUT_WIDTH.ROOM_SHORTCUTS - channel_sidebar_width - LAYOUT_WIDTH.IM - LAYOUT_WIDTH.DRAG_LINE - this.getRightBarModuleWidth()
        this.privateImStyle.maxWidth = Math.max(chat_max_width, 450)
      } else if (this.cur_link || this.reply_list_params.msg_id) {
        const link_max_width = window.innerWidth - LAYOUT_WIDTH.ROOM_SHORTCUTS - channel_sidebar_width - LAYOUT_WIDTH.IM - LAYOUT_WIDTH.DRAG_LINE
        this.linkStyle.maxWidth = Math.max(link_max_width, 450) // 450为最小宽度
      }
    },
    getPageWidth () {
      this.handleShortcutsScroll()
      const last_window_width = this.window_width
      this.window_width = window.innerWidth

      this.linkStyle.width = this.linkStyle.maxWidth = this.linkStyle.defaultWidth = Math.max(450, Math.round(window.innerWidth / 3))
      if (this.cur_private_user.user_id || this.cur_link || this.reply_list_params.msg_id) {
        // 如果正在缩小、已经是浮窗显示、宽度 < DEFAULT_SWITCH_WIDTH了，就不用计算了  
        if (this.window_width < last_window_width && !this.show_page_style && this.window_width < DEFAULT_SWITCH_WIDTH) {
          return
        }
        // 如果正在放大、已经是页面内显示、宽度 > DEFAULT_SWITCH_WIDTH了，就不用计算了  
        if (this.window_width > last_window_width && this.window_width > DEFAULT_SWITCH_WIDTH) {
          if (!this.show_page_style) {
            this.handleUpdatePageStyle(true)
          }
          return
        }
        
        // 两边当前的总宽度
        let last_chat_width = 0, new_chat_width= 0 // 上一次的宽度和新的宽度
        if (this.window_width < last_window_width) { // 缩小
          if (this.cur_link || this.reply_list_params.msg_id) {
            last_chat_width = Math.min(this.linkStyle.width, this.linkStyle.maxWidth)
          } else {
            last_chat_width = Math.min(this.privateImStyle.width, this.privateImStyle.maxWidth)
          }
          const room_shortcuts_width = LAYOUT_WIDTH.ROOM_SHORTCUTS
          const friend_list_width = LAYOUT_WIDTH.FRIEND_LIST
          const channel_sidebar_width = this.initialWidth
          // 缩小的时候需要将聊天框缩小后再浮窗显示
          if (this.window_width < DEFAULT_SWITCH_WIDTH && last_chat_width <= 450) { 
            this.handleUpdatePageStyle(false)
          } else {
            new_chat_width = Math.max(450, last_chat_width - (last_window_width - this.window_width))
            if (this.cur_link || this.reply_list_params.msg_id) {
              const width = window.innerWidth - room_shortcuts_width - channel_sidebar_width - LAYOUT_WIDTH.DRAG_LINE - LAYOUT_WIDTH.IM - this.getRightBarModuleWidth()
              this.linkStyle = {
                width: new_chat_width,
                maxWidth: Math.max(width, 300)
              }
            } else {
              const width = window.innerWidth - room_shortcuts_width - channel_sidebar_width - LAYOUT_WIDTH.DRAG_LINE - LAYOUT_WIDTH.IM - this.getRightBarModuleWidth()
              this.privateImStyle = {
                width: new_chat_width,
                maxWidth: width
              }
            }
          }
        }
        this.getDrawerMaxWidth()
      } else {
        this.handleUpdatePageStyle()
      }
    },
    startDragging(event, lineName) {
      event.preventDefault();
      this.dragging = true
      this.startX = event.clientX

      // 每次开始拖拽时计算弹窗最大宽度
      this.getDrawerMaxWidth()
      
      // 计算聊天框当前实际宽度
      if (lineName === 'inner') {
        this.initialRightWidth = Math.min(this.linkStyle.width, this.linkStyle.maxWidth)
      } else {
        this.initialRightWidth = Math.min(this.privateImStyle.width, this.privateImStyle.maxWidth)
      }
      this.draggingLineName = lineName
      this.$nextTick(() => {
        window.addEventListener('mousemove', this.drag)
        window.addEventListener('mouseup', this.stopDragging)
      })
    },
    drag(event) {
      if (this.dragging) {
        this.is_draged = true
        const diffX = this.startX - event.clientX
        this.startX = event.clientX
        this.initialRightWidth += diffX
        if (this.draggingLineName === 'inner') {
          this.linkStyle.width = Math.min(Math.max(450, this.initialRightWidth), this.linkStyle.maxWidth)
        } else if (this.draggingLineName === 'outer') {
          this.privateImStyle.width = Math.min(Math.max(450, this.initialRightWidth), this.privateImStyle.maxWidth)
        }
      }
    },
    stopDragging() {
      this.dragging = false;
      this.draggingLineName = ''
      window.removeEventListener('mousemove', this.drag);
      window.removeEventListener('mouseup', this.stopDragging);
      this.SET_LAST_PRIVATE_IM_WIDTH(this.initialRightWidth)
    },
    showCreateRoomDialog () { 
      EventBus.$dynamic('RoomCreate')
    },
    showConfig() {
      EventBus.$dynamic('UserConfig')
    },
    jumpTo(v, query) {
      setTimeout(() => {
        this.$router.push({name: v, query})
      })
    },
    jumpToToolFunc(tool) {
      tool.reportCb && tool.reportCb()
      if (tool.availableFunc.length === 1) {
        this.jumpTo(tool.availableFunc[0].route, tool.availableFunc[0].query);
      } else {
        // 功能数量>1则打开侧栏 后续迭代
      }
    },
    initWebSocket() {
      getWsId().then((res) => {
        if(res.data.status == 'ok') {
          webSocketInstance.initWebSocket();
        }
      }).catch((e) => {
        EventBus.$emit("Connect_Error", "ws_disconnect");
      })
    },
    initMiniProSetting() {
      window.electronAPI.onMiniSettingChange((evt, val) => {
        this.SET_MINIPROGRAM_SETTING(mergeLists(val, this.miniprogram_setting))
      })
      window.electronAPI.onLocalMiniSettingChange((evt, val) => {
        val = formatObj(val)
        this.SET_MINIPROGRAM_SETTING(mergeLists(val, this.miniprogram_setting))
      })
      Promise.all([getStorage('miniprogram_setting'), getStorage('local_miniprogram_enable')]).then(([val,  val2]) => {
        val = val || []
        val2 = formatObj(val2)
        this.SET_MINIPROGRAM_SETTING(mergeLists(val, val2))
      })

      function formatObj (obj) {
        obj = obj || {}
        return Object.keys(obj).map(key => {
          return {
            mini_pro_id: key,
            enable: obj[key]
          }
        })
      }
      function mergeLists(list1, list2) {
        list1 = list1 || []
        list2 = list2 || []
        const mergedMap = new Map();
        // 将 list2 中的元素添加到 Map 中
        list2.forEach(item => {
          mergedMap.set(item.mini_pro_id, item);
        });

        // 将 list1 中的元素添加到 Map 中，优先取 list1 的值
        list1.forEach(item => {
          mergedMap.set(item.mini_pro_id, item);
        });
        return Array.from(mergedMap.values());
      }
    },

    initZoomToast () {
      if (window.electronAPI && window.electronAPI.onZoomChange) {
        window.electronAPI.onZoomChange((_event) => {
          if (this._show_center_zoom_toast_timer) {
            clearTimeout(this._show_center_zoom_toast_timer)
          }
          this.show_center_zoom_toast = true
          this._show_center_zoom_toast_timer = setTimeout(() => {
            this.show_center_zoom_toast = false
          }, 1000)
        })
      }
    },
    getOnceTasks() {
      if (this._once_lock) return
      this._once_lock = true
      getOnceTasks({ _notip: 1 }).then(res => {
        if(res.data.status == 'ok'){
          const tasks = res.data.result.list || []
          this.SET_ONCE_TASK_LIST(tasks)
        }
      }).finally(() => {
        this._once_lock = false
      })
    },
    getPhoneNumInfo() {
      getAuthInfo({_notip: 1}, {}).then((res) => {
        if (res.data.status == "ok" && res.data.result) {
          let result = res.data.result

          let phoneNumberInfo = result.find((item) => item.src_id_type === 1)
          let wechatInfo = result.find((item) => item.src_id_type === 5)
          let phonenum = phoneNumberInfo ? phoneNumberInfo.src_id : undefined
          let wechatName = wechatInfo ? wechatInfo.name : undefined
          let wechatId = wechatInfo ? wechatInfo.src_id : undefined
          let has_password = result[0]?.has_password

          // -1是占位符，没实际作用
          let realBindArr = result.filter(item => item.src_id_type !== -1)
          let onlyBindWechat = (realBindArr.length === 1) && (realBindArr[0].src_id_type === 5)

          const blankInfo = result.find(item => item.src_id_type === -1) || {}
          let verified_info = null
          if (blankInfo.certified) {
            verified_info = {
              name: blankInfo.name,
              id_card: blankInfo.id_card,
            }
          }
          this.SET_USER_INFO({
            phonenum,
            wechatName,
            onlyBindWechat,
            wechatId,
            has_password,
            verified_info,
          });
          EventBus.$emit('Phonenum_Change');
        }
      });
    },
    // 接收正在游玩的游戏名称
    async receiveGamingName() {
      if (process.env.IS_CLIENT) {
        let func = async (_, value, key) => {
          const { game = {}, music = {}, steam = {} } = value
          const originPcState = JSON.parse(JSON.stringify(this.user_info.pc_state || {}))
          const { steam_game_name = '' } = steam
          const { game_name = '', certification = false, process_path = '', process_name = ''  } = game
          const { music_name } = music
          // 如果原先存在游戏名, 但是现在没有游戏名了，则清空steam的游戏状态
          if(key === 'game' && originPcState?.game?.game_name && !game_name && steam_game_name) {
            value['steam'] = {
              steam_game_name : '', 
              steam_game_state : ''
            }
          }
          this.SET_USER_INFO({ 
            pc_state: value
          })
          if (!this.ws_id) {
            await getWsId();
          }
          let res = await reportGameStatus({}, {
            ws_id: this.ws_id,
            file_path: process_path,
            process_name: process_name,
            game_name: game_name,
            music_name: music_name,
            certification,
          })
          if(res && res.data.status == 'ok') {
            this.initIndexTask()
            const { user_state } = res.data.result
            EventBus.$emit('update_user_state', { user_id: this.user_info.user_id, user_state })
          }
        }
        func(null, await window.electronAPI.getUserApplicationState())
        window.electronAPI.onChangeUserApplicationState(func)
      } else {
        this.initIndexTask()
      }

    },
    receiveTrayMsgClick () {
      // 从tray menu点击之后打开消息
      if (window.electronAPI) {
        window.electronAPI.onOpenMessage((_event, msg) => {
          if (msg) {
            if (msg.type === 'private' || msg.type === 'official' || msg.type === 'notify') {
              if (msg.type === 'official') {
                msg.id = NEW_OFFICIAL_MESSAGE_ID.heychat_sys_notify
              } else if (msg.type === 'notify') {
                msg.id = NEW_OFFICIAL_MESSAGE_ID.heybox_message_notify
              }
              this.handlePrivateIm({
                avatar: msg.avatar,
                user_id: msg.id,
                nickname: msg.name,
              }, true)
            } else if(msg.type === 'channel') {
              if (msg.room_id && msg.channel_id) {
                EventBus.$emit("Join_Room_Or_Channel", {
                  channel_id: msg.channel_id,
                  room_id: msg.room_id
                });
              }
            } else if(msg.type === 'chat_group') {
              this.handleChatGroupIm(msg.id)
            }
          }
        })

        window.electronAPI.onOpenUserSetting((_event, md) => {
          EventBus.$dynamic('UserConfig', md)
        })
      }
      
    },
    setAccountSetting(s) {
      this.SET_ONLINESTATE(s.online_state)
      this.SET_USER_INFO({
        display_last2_week_game: s.display_last2_week_game,
        display_current_playing_game: s.display_current_playing_game,
        display_current_music: s.display_current_music,
        show_in_room_state: s.show_in_room_state,
      });
      this.SET_USER_ACCOUNT_SETTINGS({
        ...s,
        allow_steam_nethook: this.setting_data.wilds_close_steam_nethook ? false : s.allow_steam_nethook
      })
      this.$rtc.initRtc()
      EventBus.$emit('User_Account_Settings_Inited')
    },
    initGameFunctions() {
      // config后续迭代从接口请求
      const config = [
        {
          tool: '/',
          functions: ['miniprogram']
        },
        // {
        //   tool: '/',
        //   functions: ['team-center']
        // },
        {
          tool: 'pubg',
          functions: ['video-report']
        }
      ];
      TOOL_FUNCTION_CONFIG.forEach((tool) => {
        tool.availableFunc = [];
        config.forEach((item) => {
          if (item.tool === tool.key) {
            tool.functions.forEach((func) => {
              if (item.functions.includes(func.key)) {
                tool.availableFunc.push(func);
              }
            })
          }
        });
      });
      this.toolFunctionConfigs = TOOL_FUNCTION_CONFIG.filter(item => item.availableFunc.length > 0);
      this.$set(this.isCompleted, 0, true)
    },
    // 缓存图片
    loadImgs() {
      let topImg = new Image(), topFriendImg = new Image();
      topImg.src = DEFAULT_ROOM_BG; // 房间详情背景图
      topFriendImg = FRIEND_CARD_BG // 个人信息详情背景
    },
    getBoxCount() {
      clearTimeout(this._getBoxCountTimeout)
      getBoxCount().then((res) => {
        if(res.data.status == 'ok'){
          this.activitityBoxCount = res.data.result.count
        }
      }).finally(() => {
        this._getBoxCountTimeout = setTimeout(() => {
          this.getBoxCount()
        }, 30 * 1000)
      })
    },
    handleAddSteamFriend(id) {
      if (!id) return
      completeOnceTask({
        _notip: 1
      }, {
        task_id: 5
      })
      window.location.href = `steam://openurl/https://steamcommunity.com/profiles/${id}/`
      // EventBus.$emit('set_dialog_visible:UseAccDialog', 'steam')
      this.$query({
        config: {
          title: "添加Steam好友需要使用加速器",
          desc: '建议使用小黑盒加速器加速Steam社区',
          confirm: {
            text: '我知道了',
          },
          cancel: {
            text: '下载小黑盒加速器',
            style: {
              width: '145px'
            }
          }
        },
        cancelCB: () => {
          getAccDownloadUrl().then(res => {
            if (res.data.status === 'ok') {
              window.open(res.data.result.DownloadUrl)
            }
          })
        }
      })
    },
    // 更新我自己的在线状态
    updateMyOnlineState (data) {
      if (data.data.setting === 'online_state') {
        if (this.online_state == data.data.value) return
        this.SET_ONLINESTATE(data.data.value)
      }
    },
    // 隐藏私聊弹窗
    handlePrivateImHide (data = {}) {
      if (data.from == 'SIDEBAR') {
        if (data.user_id === this.cur_private_user.user_id){
          this.SET_CUR_PRIVATE_USER({})
          return
        }
        return
      } else {
        this.SET_CUR_PRIVATE_USER({})
      }
    },
    handleDelFriend(friend) {
      handleDeleteFriend(friend.user_id)
    },
    // 展示私聊弹窗 or 消息通知
    handlePrivateIm(user, focus_sider = false, fromRoom) {
      if (this.cur_private_user.user_id == user.user_id) {
        this.handlePrivateImHide()
        return
      }

      // 避免出现朋友状态为空的问题 所以更新一下friends_map
      if (user.is_friend) {
        this.SET_FRIENDS({
          ...this.friends_map,
          [user.user_id]: user
        })
      }

      if (this.$route.name !== 'room') {
        this.$router.push({name: 'friends'})
      }
      this.SET_CUR_PRIVATE_USER({...user, fromRoom})
    },
    async handleChatGroupIm(groupId) {
      if (
        this.cur_group_chat.chat_group_info &&
        this.cur_group_chat.chat_group_info.chat_group_id == groupId
      ) {
        this.handleHideChatGroupIm();
        return;
      }

      enterGroupChat(groupId)
    },
    handleHideChatGroupIm() {
      this.SET_CUR_GROUP_CHAT({})
    },
    // 初始化所有房间通知设置
    getAllRoomNotify() {
      getAllRoomNotify().then((res) => {
        if (res.data.status === 'ok') {
          const result = res.data.result
          this.SET_ALL_NOTIFY_SETTINGS(result.settings)
          this.SET_ALL_CHAT_GROUP_NOTIFY_SETTINGS(result.chat_group_settings)
          this.SET_DEFAULT_NOTIFY_SETTINGS({
            default_channel_setting: result.default_channel_setting || {},
            audio_channel_default_setting: result.audio_channel_default_setting || {},
          })
          if (this._getUnreadMsg) {
            this.$unread.initUnreadStateCache()
            EventBus.$emit('initOfflineTrayMsg')
          } else {
            this._getNotifySettings = true
          }
        }
      })
    },
    showThemeManagerHandler(v, data) {
      this.themeManagerData = data
      this.SET_SHOW_THEME_MANAGER(v)
    },
    // 成员被移动到某个频道
    moveCurChannel(data) {
      let d = data.data
      if (d.room_info.room_id == this.cur_channel_data.room_id) {
        EventBus.$emit('Channel_Access:enterChannel', {
          channel: {
            ...d.channel_info,
            ...d.room_info,
          },
        });
      }
    },
    activityShortCutClick(item) { // 点击活动图标
      this.$protocol(item.act_url, {
        reportObj: {
          type: 'home-old-activity'
        }
      })
      reportData('activity:shortcut-click', {
        name: item.act_name
      })
    },
    downloadClient () {
      console.log("downloadClient")
      if (window.client_env !== 'electron') {
        reportData('client_download')
        window.location.href = this.client_download_url
      }
    },
    handleShowDownloadClientDialog (val) {
      if (window.client_env !== 'electron' && val) {
        this.$refs['shortcuts-scroller'].scrollTop = this.$refs['shortcuts-scroller'].scrollHeight
        this.$nextTick(() => {
          const dom = document.querySelector('#left-sidebar-download-btn')
          if (!dom) return
          const createroomRect = dom.getBoundingClientRect()
          
          this.dialogTop = createroomRect.top + (createroomRect.height / 2) - 220;

          this.advertiseDialogConfig = {
            name: '',
            img: 'https://imgheybox.max-c.com/oa/2023/10/16/dde79a02f93259a8e4a0f44e41788dfd.png',
            link: 'heyboxchat://download-client/',
            desc: '下载客户端！解锁游戏内覆盖、共享伴奏等功能',
            confirm_btn_text: '下载客户端',
            no_style: true,
            classes: 'tip-download-client-dialog'
          }
          this.showAdvertiseDialog = true
        })
      }
    },
    appendDownloadToBody() {
      let timer = setTimeout(() => {
        const cpt  = new Vue({
          render: h => h(DownloadBanner, {
            props: {
              show: this.showDownload,
              need_login: true
            },
            on: {
              download_client: () => {
                this.downloadClient()
              },
              'update:show': v => {
                this.SET_SETTING_DATA_PARAM({
                  hide_download_banner: !v
                })
              }
            }
          })
        });
        cpt.$mount();
        const body = document.body
        const firstChild = body.firstChild;

        const appDom = document.querySelector('#app')
        const bannerDom = document.querySelector('body>.cpt-download-banner')
        if(!bannerDom && this.$route.name === 'home'){
          body.insertBefore(cpt.$el, firstChild);
          this.showBodyBanner = true
        }
        clearTimeout(timer);
        timer = null;
      }, 200)
    },
    reportSystemVersion() {
      if (process.env.IS_CLIENT && window.windows_version)
      reportData('system-version', {
        version: window.windows_version
      })
    },
    async handleShowEmojiSelector(show, pos, source, cb) {
      if (show === false) {
        this.isShowEmojiSelector = false
        this.emojiSelectorInitData = {}
        return
      }
      if (this.isShowEmojiSelector = true) {
        this.isShowEmojiSelector = false
        await this.$nextTick()
      }
      this.isShowEmojiSelector = true
      this.emojiSelectorInitData = {
        show,
        pos,
        source,
        cb
      }
    },
    initWindowShowListener() {
      const enterPageCb = () => {
        this.SET_WINDOW_SHOW_STATE(true)
      }
      const leavePageCb = () => {
        this.SET_WINDOW_SHOW_STATE(false)
      }
      addPageVisibilityChangeListener(enterPageCb, leavePageCb)
    },
    handleCancelBanUser (user) {
      banUser({}, {
        to_user_id: user.user_id,
        duration: 0,
        reason: '',
        room_id: this.cur_room_data.room_id,
      }).then(res => {
        if (res.data.status === 'ok') {
          this.$toast.success('解除禁言成功')
          EventBus.$emit('Refresh_Member_List')
          EventBus.$emit('Refresh_Batch_Manage_List', {})
          EventBus.$emit('Refresh_Im_Msgs_Ban', {
            user_id: user.user_id,
            ban: {
              notify: false,
              until: '0',
              reason: '',
              operator_id: this.user_info.user_id,
            }
          })
        }
      })
    },
    reconnectReport() {
      this.reportUserGameState()
      if (process.env.IS_CLIENT) {
        this.reportBilibiliLivingState()
      }
    },
    reportUserGameState () {
      const { game = {}, music = {} } = this.user_info.pc_state || {}
      const { game_name = '', certification = false, process_path = '', process_name = ''  } = game
      const { music_name = '' } = music
      reportGameStatus({}, {
        ws_id: this.ws_id,
        file_path: process_path,
        process_name: process_name,
        game_name: game_name,
        music_name: music_name,
        certification,
      }, true)
    },
    onElectronStoreError () {
      window.electronAPI?.onSetLocalStoreError((_event, error) => {
        if (this._onElectronStoreErrorDone) return
        let str = error.toString()
        this._onElectronStoreErrorDone =  true
        if (str.includes('ENOSPC')) {
          this.$query({
            config: {
              title: '磁盘空间不足',
              desc: '配置文件保存失败，请清理系统盘磁盘空间',
              confirm: {
                text: '我知道了',
              },
            },
          })
        } else {
          this.$query({
            config: {
              title: '配置文件保存失败',
              desc: '请尝试使用管理员模式启动黑盒语音',
              confirm: {
                text: '我知道了',
              },
            },
          })
        }
      })
    },
    async initGlobalConfig() {
      const res = await getGlobalConfig()
      if (res.data.status === 'ok') {
        const result = res.data.result
        this.SET_GLOBAL_CONFIG(result)
        const { time_periods } = result
        if (time_periods) {
          this.SET_API_POLL_INTERVAL(time_periods)
        }
        if (process.env.IS_CLIENT) {
          this.SET_SETTING_DATA_PARAM({
            low_download_speed_threshold: result.numbers.low_download_speed_threshold,
          })
        }
        if (result.switches?.report_op_mem) {
          window.needReportUserOp = true
        }

        // 非房间的时候
        if(this.$route.name !== 'room') {
          this.SET_SHOW_FRIEND_SIDEBAR(this.$route.name !== 'home')
        }

        // 小程序入口
        this.handleMpContainerInitDone()
        setTimeout(() => {
          if (this.is_login) {
            if (!this.setting_data.show_friends_center_tip) {
              this.showFriendsCenterTip = true
            }
            if (!this.showFriendsCenterTip && !this.setting_data.show_mini_program_tip) {
              this.showMiniProgramTip = true
            }
          }
        }, 500)
        Cache.setLimit({
          'private_message_cache': result.cache_channel_count,
          'im_message_cache': result.cache_channel_count,
          'room_cache': result.cache_room_count,
        })
        this.initBilibiliStateWatch()
      }
    },
    handleInitUnreadStateCache () {
      if (this._getNotifySettings) {
        this.$unread.initUnreadStateCache()
        EventBus.$emit('initOfflineTrayMsg')
      } else {
        this._getUnreadMsg = true
      }
    },
    getFolderDone (is_init) {
      this.$set(this.isCompleted, 2, true)
      if (is_init) {
        setTimeout(() => {
          this.handleShortcutsScroll()
        }, 100)
      }
    },
    handleScrollToRoom (room_id, direction = 'top') {
      const el = this.$refs['shortcuts-scroller'].querySelector(`[data-room-id="${room_id}"]`)
      if (el) {
        el.scrollIntoView({behavior: 'smooth', block: 'center'})
      } else {
        let room = this.room_list.find(room => room.room_id === room_id)
        if (room) {
          let folder_el = this.$refs['shortcuts-scroller'].querySelector(`[data-room-id="${room.folder_id}"]`)
          folder_el && folder_el.scrollIntoView({behavior: 'smooth', block: 'center'})
        }
      }
    },
    handleInitStickyButton() {
      this.handleStickyScroll({target: {clientHeight: this.$refs['shortcuts-scroller'].clientHeight}})
    },
    handleStickyScroll (e) {
      const PADDING_GAP = 24;
      const SHORTCUTS_HEIGHT = e.target.clientHeight;
      const STICKY_WRAPPER_TOP =
        this.$refs["sticky-wrapper"].getBoundingClientRect().top;
      this.showStickyBackground =
        SHORTCUTS_HEIGHT - STICKY_WRAPPER_TOP < PADDING_GAP;
    },
    handleFriendsMsgSticky () {
      // 只有当存在红点时才启用吸顶功能
      if (!this.recent_msg_count || !this.$refs['friends-center-tip']) {
        this.showFriendsMsgSticky = false;
        return;
      }

      const friendsMsgEl = this.$refs['friends-center-tip'];
      const scrollerEl = this.$refs['shortcuts-scroller'];
      if (!friendsMsgEl || !scrollerEl) return;

      const friendsMsgRect = friendsMsgEl.getBoundingClientRect();
      const scrollerRect = scrollerEl.getBoundingClientRect();

      // 当好友与消息滚动到黑盒语音图标下方时启用吸顶
      this.showFriendsMsgSticky = friendsMsgRect.top <= scrollerRect.top + 50;
    },
    handleShortcutsScroll (d) {
      if (this.hasUnreadMsgRooms.length && this.$refs['shortcuts-scroller']) {
        // 找到屏幕可视区域外上面和下面的第一个元素对应的room_id，也就是最上面和最下面有未读消息的房间，不需要滚动
        const folder_id = this.hasUnreadMsgRooms[0].folder_id
        let first_id = folder_id || this.hasUnreadMsgRooms[0].room_id
        if (folder_id == '0') {
          first_id = this.hasUnreadMsgRooms[0].room_id
        }
        let firstRoom = this.$refs['shortcuts-scroller'].querySelector(`[data-room-id="${first_id}"]`)
        if (folder_id && folder_id != '0') {
          // 检查有没有open这个class
          if (firstRoom && firstRoom.classList.contains('open')) {
            first_id = this.hasUnreadMsgRooms[0].room_id
            firstRoom = this.$refs['shortcuts-scroller'].querySelector(`[data-room-id="${first_id}"]`)
          }
        }
        this.topRoomId = ''
        this.bottomRoomId = ''
        const BTN_HEIGHT = 54; // 减去粘贴状态的创建房间按钮高度
        if (firstRoom) {
          const rect = firstRoom.getBoundingClientRect()
          if (rect.top < -30) { // 第一个房间在最上面之外
            this.topRoomId = first_id
          } else if (rect.bottom - window.innerHeight > -15 - BTN_HEIGHT) { // 第一个房间在最下面之外
            if (this.hasUnreadMsgRooms.length === 1) {
              this.bottomRoomId = first_id
            }
          }
        }

        if (this.hasUnreadMsgRooms.length > 1) {
          const folder_id = this.hasUnreadMsgRooms[this.hasUnreadMsgRooms.length - 1].folder_id
          const last_room_id = this.hasUnreadMsgRooms[this.hasUnreadMsgRooms.length - 1].room_id
          let last_id = folder_id || last_room_id
          if (folder_id == '0') {
            last_id = last_room_id
          }
          let lastRoom = this.$refs['shortcuts-scroller'].querySelector(`[data-room-id="${last_id}"]`)
          if (folder_id && folder_id != '0') {
            if (lastRoom && lastRoom.classList.contains('open')) {
              last_id = last_room_id
              lastRoom = this.$refs['shortcuts-scroller'].querySelector(`[data-room-id="${last_id}"]`)
            }
          }
          if (lastRoom) {
            const rect = lastRoom.getBoundingClientRect()
            if (rect.bottom - window.innerHeight > -15 - BTN_HEIGHT) { // 最后一个房间在最下面之外
              this.bottomRoomId = last_id
            }
          }
        }
      }
    },
    windowFocus() {
      this.$nextTick(() => {
        document.body.setAttribute('state', 'focus')
      })
    },
    windowBlur() {
      this.$nextTick(() => {
        document.body.setAttribute('state', 'blur')
      })
    },
    shortCutsWrapperMenuHandler(event) {
      if (event.target.classList.contains('shortcut-block')) return

      let isHasUnread = !!this.room_list.find(({room_id}) => {
        let { redCount, showRedPoint} = this.$unread.getUnreadState({room_id})
        return redCount || showRedPoint
      })
      if (isHasUnread) {
        this.$contextmenu({
          groups: [
            {
              items: [
                {
                  component: 'menu-button',
                  data: {
                    label: '将所有房间标记为已读',
                  },
                  onClick: ()=>{
                    let now = new Date().getTime()
                    let _all_unread_states = JSON.parse(JSON.stringify(this.all_unread_states))
                    for (let room_id in _all_unread_states) {
                      for (let channel_id in _all_unread_states[room_id]) {
                        _all_unread_states[room_id][channel_id] = {
                          message_count: 0, 
                          mention_count: 0, 
                          last_read_message_id: 0, 
                          last_read_time: now
                        }
                      }
                    }
                    this.SET_ALL_UNREAD_STATES(_all_unread_states)
                    this.$unread.updateUnreadStateCache({
                      all_clear: true,
                    })
                    this.topRoomId = ''
                    this.bottomRoomId = ''
                    clearUnreadState({
                      _notip: 1,
                    }, {
                      all: true
                    })
                    if (process.env.IS_CLIENT) {
                      // 清除tray中所有频道消息
                      window.electronAPI.clearTrayMessageByType(['channel'])
                    }
                    EventBus.$emit("ClearUnreadStateCache",  _all_unread_states)
                  }
                },
              ]
            },
          ],
          event
        })
      }
    },
    watchPageThemeMedia() {
      const themeMedia = window.matchMedia("(prefers-color-scheme: light)");
      this.SET_SYSTEM_THEME(themeMedia.matches ? 'light' : 'dark')
      themeMedia.addEventListener('change', e => {
        this.SET_SYSTEM_THEME(e.matches ? 'light' : 'dark')
      });
      this.updaPageTheme()
    },
    updaPageTheme() {
      document.body.setAttribute('theme', this.page_theme)
      if(process.env.IS_CLIENT) {
        if(window.electronAPI && window.electronAPI.setTheme) {
          window.electronAPI.setTheme(this.page_theme)
        }
      }
    },
    async reloginAppend(){
      if(!await checkLoginStatusAsync() && !process.env.IS_CLIENT){
        this.appendDownloadToBody()
      }
    },
    removeBanner(){
      const bannerDom = document.querySelector('body>.cpt-download-banner')
      if(bannerDom){
        bannerDom.remove()
        this.showBodyBanner = false
      }
    },
    initTitleBar() {
      let firstChild = document.body.firstChild
      if (firstChild && firstChild?.classList?.contains(TITLE_BAR_CLASS)) { // 已经添加过titlebar, 不重复添加
        return
      }
      
      const TitleBarConstructor = Vue.extend(TitleBar)
      const instance = new TitleBarConstructor({
        store: this.$store
      })
      instance.$mount()
      document.body.insertBefore(instance.$el, firstChild)
    },
    initObsListener(){
      if(window.obsOverlayAPI) {
        let func = (_, data) => {
          this.jumpRoomChannel(data, 'obs-overlay')
        }
        window.obsOverlayAPI.obsJump(func)

        let func2 = (_, data) => {
          const port = data
          let urlOrigin =''
          if (process.env.IS_PROD) {
            urlOrigin = 'https://chat.xiaoheihe.cn'
          } else if (process.env.IS_TEST) {
            urlOrigin = 'https://chat.debugmode.cn'
          } else {
            urlOrigin = window.location.origin
          }

          const url = `${urlOrigin}/obs-overlay?port=${port}`
          window.open(url)
        }
        window.obsOverlayAPI.getPort(func2)
      }
    },
    // 处理web_token登录
    async handleWebTokenLogin(web_token, invite_code) {
      try {
        let {data: { status, result }} = await getPkeyWithToken({
          token: web_token,
          _notip: 1,
          hkey: '',
        })

        if (status === 'ok') {

          if (result.error === "ok") {
            setCookie('heybox_id', result.heyboxid);
            setCookie('user_heybox_id', result.heyboxid);
            setCookie('avatar', result.avatar);
            setCookie('nickname', result.nickname);
            reportLogin('token')

            window.electronAPI.sendInviteCode(invite_code)

            window.location.reload()
          } else {
            this.$toast.error('token 已过期')
          }
        } 
      } catch (e) {
        console.error('Web token login failed:', e)
      }
    },
    initElectronShowToast(){
      let func = (_, data) => {
        this.$toast.info(data)
      }
      window.electronAPI && window.electronAPI.listenShowToast(func)
    },
    // 统一处理点击富文本消息中的链接
    async handleRichMessageLinkClick (event, msg, is_private_im, is_reply_detail) {
      if (!event) return
      const target = event.target
      const href = target.href;
      const links = msg.links || []
      const link = links.find(item => item.url === href)
      if (link && link.link_type == PARSE_LINK_TYPE.invite) {
        let data = this.handleJumpToMsg(link)
        if (data.channel_id) {
          // 当前房间的话，覆盖当前频道即可，因为语音频道也是进仅聊天
          if (data.room_id == this.cur_room_data.room_id) {
            const channel = await findChannel(data.channel_id)
            if (!channel) {
              this.$toast.error('频道不存在')
              return
            }
            if(checkIsResourceChannel(channel, this.cur_room_whole_data)) {
              EventBus.$emit('ChannelSidebar:clickStaticChannel', null, null, CHANNEL_TYPES.guidance, {
                jumpData: data.channel_id
              })
            } else {
              EventBus.$emit('Channel_Access:enterChannel', {
                channel,
                use_audio: 0
              })
            }
          } else { // 其他房间的话要通过邀请码进
            this.jumpRoomByCode({
              invite_url: link.url, 
              show_toast: true, 
              only_text: data.only_text
            })
          }
        } else if (data.room_id) {
          this.jumpRoomByCode({
            invite_url: link.url, 
            show_toast: true, 
            only_text: data.only_text
          })
        }
        if (is_private_im) {
          this.SET_CUR_PRIVATE_USER({})
        }
      } else if (link?.link_type == PARSE_LINK_TYPE.normal) {
        const addition = link.addition ? JSON.parse(link.addition) : {}
        if (addition.link_id) {
          let type = 'article'
          if (addition.has_video) {
            type = 'video'
          } else if (addition.use_concept_type) {
            type = 'concept'
          }
          this.showLinkDetail(addition.link_id, 0, type)
          if (is_private_im) {
            this.SET_CUR_LINK_FROM({
              type: 'msg',
              msg_id: msg.seq,
              user_id: this.cur_private_user.user_id,
            })
            this.SET_CUR_PRIVATE_USER({})
          }
        } else {
          window.open(target)
        }
      } else {
        window.open(target)
      }
    },
    handleJumpToMsg(link) {
      const additon = link.addition ? JSON.parse(link.addition) : {}
      const { msg_id, room_id, channel_id, channel_type } = additon
      if (room_id) {
        const obj = { room_id }
        if (channel_id) {
          obj.channel_id = channel_id
          if (CHANNEL_TYPES.has_audio_types.includes(channel_type)) {
            obj.only_text = true
          }
        }
        if (msg_id && channel_id) {
          if (channel_id == this.channel_data.channel_id) {
            EventBus.$emit('JumpToMsg', msg_id, false, true)
            return {}
          } else {
            setStorage('await_jump_msg', {
              channel_id: channel_id,
              msg_id,
            })
          }
        }
        return obj
      }
      return {}
    },
    initListenCs2InjectNotice() {
      window.electronAPI && window.electronAPI.onShowCs2InjectNotice(() => {
        this.$query({
          config: {
            desc: 'CS2支持第三方平台（如完美、5E等）直接使用，暂不支持CS2官匹直接使用，需在Steam游戏属性-已安装文件-启动选项中增加-allow_third_party_software。',
            confirm: {
              text: '复制参数',
            },
            cancel: {
              text: '我知道了',
            }
          },
          confirmCB: () => {
            copyText('-allow_third_party_software')
          }
        })
      })
    },
    async initBilibiliStateWatch() {
      if (!this.global_check_bilibili) return

      if (window.electronAPI) {
        let func = (v) => {
          let old_bilibili_living = this.bilibili_living
          this.SET_BILIBILI_LIVING(v)
          this.reportBilibiliLivingState()
          if (v !== old_bilibili_living && this.cur_channel_data.members?.some((user) => user.user_id != this.user_info.user_id && !user.verified)) {
            this.cur_channel_data.members.forEach(user => {
              if (!user.verified) {
                this.$rtc.changeUserVolume(user.user_id)
                this.$rtc.changeUserVolume(ADD_USER_BGM_SUFFIX(user.user_id))
                if (this.screen_sharing_info.user_id === user.user_id) {
                  this.$rtc.stopWatchScreenShare()
                }
              }
            })
          }
        }
        window.electronAPI.onBiliBiliLiveStateChange(async (_, v) => {
          await getWsId()
          func(v)
        })
        await getWsId()
        func(await window.electronAPI.getBiliBiliLiveState())
      }
    },
    reportBilibiliLivingState() {
      if (!this.global_check_bilibili) return

      updateBilibiliLivingState({
        ws_id: this.ws_id,
        start: this.bilibili_living ? 1 : 0,
      })
    },
    // 开关语音轮盘，注册/解绑 返回扁平语音包数据
    enableLaughterRoulette(v) {
      if (!process.env.IS_CLIENT) return
      if (v) {
        window.laughterAPI.onSendLaughterFlattenList(() => new Promise((resolve) => {
          if(this.is_init_laughter_tracks) {
            resolve(this.laughter_flatten_list)
          } else {
            EventBus.$emit('Refresh_User_Laughter', () => {
              resolve(this.laughter_flatten_list)
            })
          }
        }))
      } else {
        window.laughterAPI.offSendLaughterFlattenList()
      }
    },
    // 跳转至房间 & 频道全局封装
    jumpRoomChannel(data, pos, tag) {
      let { channel_id, room_id } = data;
      if (!room_id) return;

      EventBus.$emit("Join_Room_Or_Channel", data);
      if (pos) {
        reportData("jump-room", {
          pos,
          channel_id,
          room_id,
          tag,
        });
        window._reportEnterRoom = {
          room_id,
          click_time: Date.now(),
          entrance: pos,
        };
      }
    },
    async checkRouteData() {
      // 用户从黑盒语音官网进入，需要展示反馈弹窗
      const { query } = this.$route
      const { requireFeedback } = query
      if(requireFeedback){
        const isLogin = await checkLoginStatusAsync()

        const useFeedbackFunc = () => {
          EventBus.$dynamic("UserConfig", 'feedback')
          this.$delete(this.$route.query, 'requireFeedback')
        }
        if(isLogin) {
          // 已登录直接进行跳转
          this.$nextTick(() => {
            useFeedbackFunc()
          })
        }
      }
    },
    async reportExposure() {
      let addition = {}
      if (process.env.IS_CLIENT && window.electronAPI) {
        addition['is-auto'] = await window.electronAPI.getIsAutoStart()
        addition = {
          ...addition,
          ...await window.electronAPI.getReportRectParams()
        }
      }
      reportData('visit', addition)
    },
    isToolActive(tool) {
      return tool.availableFunc
        .filter(i => !i.disable_active)
        .map(i => i.route)
        .includes(this.$route.name)
    },
    handleShowCreateRoom() {
      EventBus.$dynamic("RoomCreateDialog");
    },
    initAddRoomSticky() {
      this.resizeObserver = new ResizeObserver(throttle(this.handleInitStickyButton, 100));
      this.resizeObserver.observe(this.$refs['shortcuts-scroller']);
      this.resizeObserver.observe(this.$refs['shortcuts-list']);
      this.resizeObserver.observe(this.$refs["sticky-wrapper"]);
    },
    destroyAddRoomSticky() {
      this.resizeObserver.disconnect();
    },
    handleChangeOverlayPositionSetterShow(showValue, positionObj = {top: 0, left: 0}, setPath = '', customData = null) {
      this.showOverlayPositionSetter = showValue;
      this.overlayPosition = positionObj;
      this.overlayPositionSetPath = setPath
      this.overlayPositionCustomData = customData
      this.handleShowElectronTitleBar(!showValue)
    },
    initElectronCallQueryDialog() {
      if(process.env.IS_CLIENT && window.electronAPI) {
        let func = (_, data) => {
          this.$query(data)
        }
        window.electronAPI.callQueryDialog(func)
      }
    },
    handleShowElectronTitleBar(showVal) {
      const titleBar = document.querySelector('.cpt-electron-title-bar')
      if(titleBar) {
        if (showVal) {
          titleBar.classList.remove('hide')
        } else {
          titleBar.classList.add('hide')
        }
      }
    },
    initElectronExitApp() {
      let func = async () => {
        await this.$rtc.closeVoiceRecord();
      }
      window.electronAPI && window.electronAPI.onUserExit(func)
    },
    async handleStartMiniProgram() {
      const {
        query: { mini_pro_id },
      } = this.$route;
      const {
        data: { status, result },
      } = await getSharePageInfo({
        mini_pro_id,
        _notip: 1,
      });
      if (status === 'ok') {
        const protocol = result.share_page.protocol
        // 客户端环境直接打开小程序
        if (process.env.IS_CLIENT) {
          this.$protocol(protocol);
        } else {
          const urlObj = new URL(protocol)
          const { hostname, searchParams } = urlObj
          
          let type = ''
          let params = {}
          for(let [key, val] of searchParams) {
            if(key === 'type') {
              type = val
            } else if(key === 'params') {
              params = JSONParse(val)
            }
          }

          const newHref = 'heychat://' + encodeURIComponent(JSON.stringify({
            protocol_type: hostname,
            type,
            params: encodeURIComponent(JSON.stringify(params)),
          }))

          window.location.href = newHref
          EventBus.$dynamic('MiniProgramShareDialog', result)   
        }
      }
      this.$router.replace({ query: { ...this.$route.query, mini_pro_id: undefined } });
    },
    handleMpContainerInitDone() {
      this.$set(this.isCompleted, 3, true)
    },
    handleUpdatePageStyle(value) {
      this.show_page_style = value ?? window.innerWidth > DEFAULT_SWITCH_WIDTH
    },
    handleChangeEmojiSelectorMouseEnter(value) {
      if(this.ifScreenShareDom && this.showScreenShare) {
        this.SET_IS_SHOW_SCREEN_SHARE_MENU(value)
      } 
    },
    // 后台拉起的通用Query弹窗
    handleShowUniversalQuery(wsData) {
      const { event, ...queryConfig } = wsData.data
      const handleRequest = (type) => {
        if(!event) return
        universalQuery({}, {
          event,
          type,
        })
      }
      this.$query({
        config: queryConfig,
        confirmCB: () => handleRequest('confirm'),
        cancelCB: () => handleRequest('cancel'),
        textBtnCB: () => handleRequest('text_btn'),
      })
    },
    handleGetLayoutWidth() {
      EventBus.$emit('Layout_Width_Changed', this.layoutWidthAbout)
    },
    handleTeamVoiceInvite(data) {
      const { user_id, channel_id, global_team_info } = data;
      const { room_id } = global_team_info;
      // 如果发起人是当前用户
      if (user_id == this.user_info.user_id) {
        return;
      }
      // 如果当前用户在推送频道
      if (this.cur_global_team.bind_chan_id == channel_id) {
        return;
      }

      this.$query({
        config: {
          title: '当前队伍已发起语音邀请，是否加入？',
          confirm: {
            text: '加入',
          },
          cancel: {
            text: '取消',
          },
        },
        confirmCB: async () => {
          const team_id = channel_id;
          const isInTeam = this.cur_global_team.members?.some(member => member.heybox_id == this.user_info.user_id);
          if(!isInTeam) {
            await joinGlobalTeam(
              {},
              {
                team_id,
              }
            );
          }
          if(this.cur_room_data.room_id === room_id) {
            this.handleJoinTeamAudio(team_id);
            if (this.cur_text_channel_data.channel_type !== CHANNEL_TYPES.global_team) {
              EventBus.$emit('ChannelSidebar:clickStaticChannel', null, null, CHANNEL_TYPES.global_team);
              handleEnterGlobalTeam(team_id)
            } else {
              handleEnterGlobalTeam(team_id);
            }
          } else {
            EventBus.$emit(
              'Join_Room_Or_Channel',
              {
                room_id: room_id,
              },
              '',
              {
                switch_to_global_team: team_id
              }
            );
          }
        },
      });
    },
    getVoiceInviteReqBody(team_id) {
      const body = {
        team_id: team_id || this.cur_global_team.team_id,
      };
      if (this.global_team_setting.appid) {
        body.appid = this.global_team_setting.appid;
      } else {
        body.room_id = this.cur_room_data.room_id;
      }
      return body;
    },
    async handleJoinTeamAudio(team_id) {
      const body = this.getVoiceInviteReqBody(team_id);
      const {
        data: { status, result },
      } = await voiceInviteToGlobalTeam({}, body);
      if (status === 'ok') {
        const { room_id, invite_code, channel_id } = result;
        if (this.cur_room_data.room_id === room_id) {
          this.handleSilenceEnterChannel(result);
        } else {
          handleEnterRoom(
            invite_code,
            ENTER_BY_INVITE_CODE_TYPES.global_team_chat,
            {
              successCb: () => {
                this.handleSilenceEnterChannel(result);
              },
            }
          );
        }
      }
    },
    handleSilenceEnterChannel(channelData) {
      EventBus.$emit('Channel_Access:enterChannel', {
        channel: channelData,
        is_silence_enter: true,
        use_audio: 1,
        cb: () => {
          EventBus.$emit('GlobalTeam:restartAutoRefreshTeamInfo');
        },
      });
    },
    ...mapMutations([
      "SET_USER_INFO", 
      "SET_WS_ID", 
      'SET_BLACKLIST', 
      'SET_INVISIBLELIST',
      'SET_ONLINESTATE',
      'SET_CUR_CHANNEL_DATA',
      'SET_CUR_PRIVATE_USER',
      'SET_ALL_NOTIFY_SETTINGS',
      'SET_DEFAULT_NOTIFY_SETTINGS',
      'SET_LAST_PRIVATE_IM_WIDTH',
      'SET_INDEX_TASK',
      'SET_ACT_LIST',
      'SET_SHOW_THEME_MANAGER',
      'SET_ONCE_TASK_LIST',
      'SET_API_POLL_INTERVAL',
      'SET_WINDOW_SHOW_STATE',
      'SET_GLOBAL_CONFIG',
      'SET_SYSTEM_THEME',
      'SET_CUR_LINK',
      'SET_CUR_LINK_FROM',
      'SET_RIGHT_BAR_MODULE',
      'SET_SHOW_FRIEND_SIDEBAR',
      'SET_ALL_UNREAD_STATES',
      'SET_ACTIVE_USER_CARD',
      'SET_ACTIVE_SIDEBAR_TAB',
      'SET_USER_THEME_SETTING',
      'SET_AVATAR_MAIN_COLOR',
      'SET_BILIBILI_LIVING',
      'SET_LAUGHTER_BLACKLIST',
      'SET_REPLY_LIST_PARAMS',
      'SET_RECENT_MINI_PRO',
      'SET_MINIPROGRAM_SETTING',
      'SET_RECENT_MSG_COUNT',
      'SET_FRIENDS',
      'SET_ALL_CHAT_GROUP_NOTIFY_SETTINGS',
      'SET_CUR_GROUP_CHAT',
      'SET_POST_MSG_UNREAD',
      'SET_CUR_GLOBAL_TEAM',
      'SET_USER_VERIFIED_STATUS',
      'SET_INIT_NET_ERROR',
    ]),
    ...mapActions([
      'SET_SETTING_DATA_PARAM',
      'SET_SHOW_RIGHT_BAR_MODULE',
      'SET_USER_ACCOUNT_SETTINGS',
      'SET_ROOM_NOTIFY_SETTINGS',
      'SET_ANCHOR_WHITE_LIST',
    ]),
  },
}
</script>

<style lang="scss">
@import "./shortcut.scss";
.l-home-layout-wrapper {
  .left-sidebar-layout {
    .icon {
      height: 26px;
      width: 26px;
      margin: 17px 4px 16px 4px;
      position: absolute;
      bottom: 3px;
      flex-shrink: 0;
      border-radius: 3px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      color: $d-op-5;
      
      i {
        font-size: 18px;
      }

      &:hover {
        background: $d-op-1;
      }
    }

    .split {
      width: 42px;
      height: 1px;
      background: $d-ln-4;
      margin: 18px 0;
      margin-top: 64px;
    }
    .guide-create-room-btn {
      position: absolute;
      top: -16px;
      left: 16px;
      width: 46px;
      height: 46px;
      display: flex;

      .cpt-poping-icon {
        position: static;
      }

      .trigger-click-area {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 20px;
        left: -18px;
        border-radius: 10px;
        cursor: pointer;
      }
    }
  }

  .layout-content-outer {
    height: 100%;
    width: 100%;
    flex: 1;
    overflow: hidden;
    border-radius: 8px 8px 0 8px;
    display: flex;
    flex-direction: column;
  }

  .layout-content-wrapper {
    height: 0;
    width: 100%;
    display: flex;
    flex: 1;
    background-image: $d-bg-ln-1;
    position: relative;

    .slider-friends,
    .cpt-channel-search-wrapper,
    .cpt-room-team-wrapper,
    .cpt-channel-feedback,
    .cpt-group-chat-more {
      padding-top: 51px;
    }

    .layout-bg-wrapper {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      transition: background-color 0.5s cubic-bezier(0.25, 0.1, 0.25, 1);

      .layout-bg {
        width: 100%;
        height: 100%;
        background-size: cover;
        background-position: center;
      }
    }

    .layout-content {
      height: 100%;
      width: 0;
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
    }

    .link-detail {
      position: relative;
      min-width: 300px;
      z-index: 1000;
    }

  }

  .split-drag-line,
  .private-im-drag-line {
    width: 10px;
    height: 100%;
    cursor: col-resize;
    background: $d-fl-nv;
    position: relative;

    .drag-border {
      position: absolute;
      left: -1px;
      top: 0;
      width: 12px;
      height: 100%;
      border: 1px solid rgba(#FFF, .04);
      border-top: none;
      border-bottom: none;
      z-index: 5;
    }

    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      transform: translateX(-50%);
      width: 2px;
      height: 16px;
      background: rgba(#FFF, .08);
      box-sizing: border-box;
    }

    &::before {
      left: 2px;
    }

    &::after {
      right: 0;
    }
  }

  .slider-friends {
    height: 100%;
    flex-shrink: 0;
    position: relative;
    display: flex;
    .sidebar {
      border-left: 1px solid $d-op-1;
    }
  }
  
  .split-drag-line {
    margin-top: 51px;
    height: calc(100% - 51px);
  }

  .sidebar-enter {
    width: 0;
  }

  .sidebar-enter-to {
    width: 280px;
  }

  .sidebar-enter-active {
    transition: all .1s ease-out;
  }
}
.tip-download-client-dialog {
  &::after {
    top: 213px!important;
  }
}
</style>
